// --- NEW CODE BLOCK: ADD THIS TO THE VERY TOP OF GLOBAL.JS, OUTSIDE ANY LISTENER ---

// Define a constant key for storing the pending checkout URL in local storage (GLOBAL SCOPE)
const CHECKOUT_LS_KEY = 'pending_checkout_url'; 

/**
 * [GLOBAL FUNCTION] Parses the URL for 'checkout_url' and saves it to localStorage.
 * This runs when the login page first loads via the quote link.
 */
function saveCheckoutUrlToLocalStorage() {
    if (window.location.pathname.includes('/account/login')) {
        const urlParams = new URLSearchParams(window.location.search);
        const checkoutUrlEncoded = urlParams.get('checkout_url'); 

        if (checkoutUrlEncoded) {
            try {
                const urlCheckoutDecoded = decodeURIComponent(checkoutUrlEncoded);
                localStorage.setItem(CHECKOUT_LS_KEY, urlCheckoutDecoded);
                console.log('Global JS: Saved checkout URL to localStorage.');
            } catch (e) {
                console.error('Global JS: Error decoding or saving checkout URL:', e);
            }
        }
    }
}

/**
 * [GLOBAL FUNCTION] Checks localStorage for a saved checkout URL and redirects if found.
 * This is called after a successful login.
 * @returns {boolean} True if a redirect occurred, false otherwise.
 */
function checkAndRedirectToCheckout() {
    const redirectUrl = localStorage.getItem(CHECKOUT_LS_KEY);

    if (redirectUrl) {
        console.log('Login successful. Redirecting to saved checkout URL:', redirectUrl);
        // 1. Clear the stored URL immediately before redirecting to avoid looping
        localStorage.removeItem(CHECKOUT_LS_KEY); 
        // 2. Perform the redirect
        window.location.href = redirectUrl;
        return true; 
    }
    return false; 
}

// --- END NEW GLOBAL SCOPE CODE ---

// Your existing first DOMContentLoaded block should now only contain the call:
window.addEventListener('DOMContentLoaded', () => {
    // --- [NEW INITIALIZATION POINT] Run the save function on page load ---
    saveCheckoutUrlToLocalStorage();
});
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger, ScrollToPlugin);
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
// async function loadCartFromCookie(email) {
//     const cartData = getCookie(`cart_${email}`);
//     if (!cartData) {
//         console.log('No cart data found in cookie.');
//         return;
//     }

//     const cartInfo = JSON.parse(decodeURIComponent(cartData));
//     console.log('Loaded cart info from cookie:', cartInfo);

//     if (!Array.isArray(cartInfo)) {
//         console.error('Cart info is not an array. Please check the saved cookie data.');
//         return;
//     }

//     try {
//         // Clear the current cart before adding items
//         // await clearCurrentCart();

//         // Sequentially add each item to the cart with a delay
//         for (const item of cartInfo) {
//             console.log(`Adding item to cart: ID=${item.id}, Quantity=${item.quantity}`);
//             await addItemToCart(item.id, item.quantity);
//             await delay(200);  // Introduce a 200ms delay; adjust if needed
//         }

//         console.log('All items have been added to the cart successfully.');
//     } catch (error) {
//         console.error('Error updating cart:', error);
//     }
// }
// function clearCurrentCart() {
//   return fetch('/cart/clear.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   }).then(response => {
//     if (!response.ok) throw new Error('Failed to clear cart');
//     return response.json();
//   });
// }
// function addItemToCart(variantId, quantity) {
//     // First, check if the item is already in the cart
//     return fetch('/cart.js')
//         .then(response => {
//             if (!response.ok) throw new Error('Failed to fetch cart contents');
//             return response.json();
//         })
//         .then(cart => {
//             // Check if the item already exists in the cart
//             const itemExists = cart.items.some(item => item.id === variantId);

//             if (itemExists) {
//                 console.log('Item is already in the cart');
//                 return Promise.resolve('Item already in cart');
//             }

//             // If item is not in the cart, add it
//             return fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     id: variantId,
//                     quantity: quantity
//                 })
//             })
//             .then(response => {
//                 if (!response.ok) throw new Error('Failed to add item to cart');
//                 return response.json();
//             })
//             .then(data => console.log('Item added to cart:', data))
//             .catch(error => console.error('Error adding item to cart:', error));
//         })
//         .catch(error => console.error('Error fetching cart contents:', error));
// }

function deleteCookie(name) {   
  document.cookie = name + "=; Max-Age=-99999999;";  
}
function saveCartWithEmail(email) {
  console.log('Attempting to save cart for:', email);
  fetch('/cart.js')
    .then(response => {
        if (!response.ok) {
            console.error('Failed to fetch cart:', response.statusText);
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cartData => {
        console.log('Cart data fetched successfully:', cartData);
        if (!cartData || !cartData.items) {
            console.error('Cart data is empty or not in expected format.');
            return;
        }


        // Create the items array
        const items = cartData.items.map(item => ({
            id: item.id,
            quantity: item.quantity
        }));

        console.log('Items to save in cookie:', items);
        // Convert the items array to a JSON string
        const itemsString = JSON.stringify(items);
        console.log('Items string for cookie:', itemsString);

        // Check length of itemsString to debug size
        console.log('Length of items string:', itemsString.length);

        // Save to cookie
        setCookie(`cart_${email}`, encodeURIComponent(itemsString), 7); // Store for 7 days

        console.log('Current cookies:', document.cookie); // Check current cookies       
      setTimeout(() => {
        location.reload();
      }, 200);
    })
    .catch(error => console.error('Error fetching cart details:', error));
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

if(window.location.hash) {
  $('.create-password').removeClass('hidden');
  $('.reset-password').addClass('hidden');
  $('.reset-password').remove();
} else {
  $('.create-password').addClass('hidden');
  $('.create-password').remove();
  $('.reset-password').removeClass('hidden');  
}


customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// custom header

// blog

const headerLinkBlogDesktop = document.querySelector('.header__inline-menu a.blog_link');
const headerBlockBlog = document.querySelector('.header-block-blog');
const ordersInfosWrapper = document.querySelector('.header-orders-infos-wrapper');
const accountContainerMobile = document.querySelector('.header-mobile-container .account-container');

if(headerLinkBlogDesktop){
headerLinkBlogDesktop.addEventListener('click', (e) => {
  if(headerLinkBlogDesktop.dataset.prevent === "true"){
    e.preventDefault();
    if(headerBlockBlog){
      headerBlockBlog.classList.toggle('active');
    }
    headerLinkBlogDesktop.classList.toggle('active');
  }
})
}

// login desktop

const globalLinkLogin = document.querySelector('.header-link-account');
const navbarBlock = document.querySelector('.navbar-block');
const accountContainer = document.querySelector('.account-container');
const btnSubmit = document.querySelector('#login-ajax-form button[type="submit"]');
const btnSubmitRP = document.querySelector('#password-reset-ajax-form button[type="submit"]');
if(navbarBlock){
navbarBlock.addEventListener('click', popLogin);
  if(!navbarBlock.classList.contains('connected')){
  globalLinkLogin.addEventListener('click', preventForm);
}
}



function popLogin(){
  if(navbarBlock.classList.contains('connected') && !navbarBlock.classList.contains('in-account')){
    navbarBlock.querySelector('span').classList.add('green');
    window.location.href = window.Shopify.routes.root + 'account';
  } else if(!navbarBlock.classList.contains('connected')){
    accountContainer.classList.toggle('active');
    navbarBlock.classList.toggle('active');
  }
}

function preventForm(e){
  if(e.target !== btnSubmit && e.target !== btnSubmitRP){
    e.preventDefault()
  }
}

// login slider

const sliderLogin = document.querySelector('.account-slider-moving');
const btnPassword = document.querySelector('.reset-password-link:not(.popup-reset-password-link) > span');
const btnBackLogin = document.querySelector('.back-login > span');
const inputLoginEmail = document.querySelector('#login_email');
const inputLoginPassword = document.querySelector('#login_password');
let indexSlider = 0;

const inputResetPassword = document.querySelector('#password_reset_email');

const loginErrorEmail = document.querySelector('.login-error.error-email');
const loginErrorPassword = document.querySelector('.login-error.error-password');

let formSuccess = false;
if(inputLoginEmail){
inputLoginEmail.addEventListener('input', () => {
  if(loginErrorEmail.innerText.length !== 0){
    displayLoginErrors(inputLoginEmail.value, inputLoginPassword.value);
  }
})
inputLoginPassword.addEventListener('input', function(){
  displayLoginErrors(inputLoginEmail.value, inputLoginPassword.value);

  const eyeBtnsConnexionDesktop = document.querySelectorAll('.eye-btn-connexion')[0];

  if(this.value === ""){
    eyeBtnsConnexionDesktop.style.display = "none";
  } else{
    eyeBtnsConnexionDesktop.style.display = "inline-flex";
  }
})

btnPassword.addEventListener('click', () => {
  indexSlider = 1;
  inputResetPassword.value = inputLoginEmail.value;

  updateSliderLogin(indexSlider);
  setTimeout(() => {
    inputResetPassword.focus();
  }, 300);
})

btnBackLogin.addEventListener('click', () => {
  indexSlider = 0;
  updateSliderLogin(indexSlider);

  setTimeout(() => {
    inputLoginEmail.focus();

    const passwordResetForm = document.querySelector('#password-reset-ajax-form');
    if (passwordResetForm) passwordResetForm.classList.add('active');

    const resetSuccessContainer = document.querySelector('.reset-success-container');
    if (resetSuccessContainer) resetSuccessContainer.classList.remove('active');
  }, 300);
});

}

function updateSliderLogin(index){
  sliderLogin.style.transform = `translateX(-${index}00%)`;
}

// ajax reset password

const formRP = document.querySelector('#password-reset-ajax-form');
const RPErrorEmail = document.querySelector('.password-reset-error.error-email');
const inputRPEmail = document.querySelector('#password_reset_email');
if(inputRPEmail){
inputRPEmail.addEventListener('input', () => {
  if(RPErrorEmail.innerText.length !== 0){
    displayPRErrors(inputRPEmail.value);
  }
})
}

let formRPSuccess = false;

const backToFormBtn = document.querySelector('.back-to-form');
if(backToFormBtn){
backToFormBtn.addEventListener('click', () => {
  stepReset('form');
  inputRPEmail.value = "";
  inputRPEmail.focus();
})
}

if(formRP){
formRP.addEventListener('submit', (e) => {
  e.preventDefault();

  const email = inputRPEmail.value;
  const loaderSubmit = document.querySelector('.rp-loader-submit:not(.rp-loader-submit-popup)');

  displayPRErrors(email);

  function maskEmail(email, threshold = 10) {
    const match = email.match(/^([^@]+)@(.+)$/);
    if (!match) return email; // fallback if invalid email

    const localPart = match[1];
    const domain = match[2];

    if (localPart.length <= threshold) {
      return `${localPart}@${domain}`;
    } else {
      return `${localPart.slice(0, threshold)}…@${domain}`;
    }
  }


  if(formRPSuccess){
    loaderSubmit.classList.add('active');

    passwordReset(email).done(function (html) {
      loaderSubmit.classList.add('active');

      if(html.indexOf('id="RecoverEmail-email-error"') !== -1){
        loaderSubmit.classList.remove('active');

        stepReset('error');
        document.querySelector('.email-reset.error').innerText = maskEmail(email);
      }
      else{
        loaderSubmit.classList.remove('active');

        stepReset('success');
        document.querySelector('.email-reset.success').innerText = maskEmail(email);
      }
    })
    .fail(function (xhr) {
      loaderSubmit.classList.remove('active');

      if (xhr.status === 429) {
        // Show too many attempts error
        document.querySelector('.too_many_attempt_error').style.display = 'inline';

        // Hide submit button
        const submitBtn = document.querySelector('#password-reset-ajax-form button[type="submit"]');
        if (submitBtn) {
          submitBtn.style.display = 'none';
        }

      } else {
        stepReset('error');
        document.querySelector('.email-reset.error').innerText =
          "Something went wrong. Please try again.";
      }
    });
  }

  function passwordReset(email) {
    let data = {
      'email': email,
      form_type: 'recover_customer_password',
      utf8: '✓'
    };
  
    let promise = $.ajax({
      url: '/account/recover',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });
  
    return promise;
  }

})
}
// ajax login

const formLogin = document.querySelector('#login-ajax-form');
if(formLogin){
formLogin.addEventListener('submit', (e) => {
  e.preventDefault();

  const loaderSubmit = document.querySelector('.login-loader-submit:not(.login-loader-submit-popup)');
  const errorLogin = document.querySelector('.error-login:not(.error-login-popup)');
  const email = inputLoginEmail.value;
  const password = inputLoginPassword.value;
  const navAccountText = document.querySelector('.navbar-block > span')

  displayLoginErrors(email, password);

  errorLogin.classList.remove('active');

  if(formSuccess){
    loaderSubmit.classList.add('active');

    login(email, password).done(function (html) {
      if (html.indexOf('deleted') !== -1) {
        $.ajax({
          url:'/account/logout',
          async:true,
        })

        errorLogin.classList.add('active');
        loaderSubmit.classList.remove('active');
        inputLoginPassword.blur();

        return;
      }

      if (html.indexOf('<div class="errors">') !== -1) {
        errorLogin.classList.add('active');

        loaderSubmit.classList.remove('active');
      } else {
        // 1. Check for a pending checkout URL saved in localStorage.
        const redirected = checkAndRedirectToCheckout();

        if (redirected) {
              // If checkAndRedirectToCheckout returned true, the redirect is happening. Stop here.
              loaderSubmit.classList.remove('active');
              return; 
        }
        const headerLinkCart = document.querySelector('.header-link-cart');
        headerLinkCart.classList.add('connected');
  
        accountContainer.classList.remove('active');
  
        navbarBlock.classList.add('connected');
        navbarBlock.classList.remove('active');
        navAccountText.innerHTML = navAccountText.dataset.myAccount;
  
        globalLinkLogin.removeEventListener('click', preventForm);
        
        const headerMobileContainer = document.querySelector('.header-mobile-container');
        headerMobileContainer.classList.add('connected');
  
        loaderSubmit.classList.remove('active');

        // display form contact and update mobile header
        const titleFullName = document.querySelector('.block-title-deconnexion h3 .header-full-name');
        const titleCompany = document.querySelector('.block-title-deconnexion h3 .header-mobile-company');
        const titleUsername = document.querySelector('.block-title-deconnexion h4');
        
        const data = getAllData(html);

        const menuMobileMyOrders = document.querySelector('.header-my-account.orders');
        const ordersCount = getOrderCount();

        if(ordersCount == "0"){
          menuMobileMyOrders.style.display = "none";
        } else{
          menuMobileMyOrders.style.display = "block";
        }
        openHeaderMobileToggleAccount()

        const fullName = data.first_name + " " + data.last_name;
        const username = data.username;

        if(fullName.length > 12) {
          userNamevalue = fullName.slice(0, 12)
        }else if(fullName.length < 8) {
          var lengthRemain = 8 - fullName.length;
          var randomNumbers = ['12345678', '87654321', '13572468', '24681357'];
          var currentTime = Date.now();
          var randomIndex = currentTime % randomNumbers.length;
          var randomPadding = randomNumbers[randomIndex].slice(0, lengthRemain);
          userNamevalue = fullName+randomPadding;
        }

        CF.customer.set("nom_dutilisateur", userNamevalue);

        titleFullName.innerHTML = `<span>${fullName}</span><svg xmlns="http://www.w3.org/2000/svg" width="5.961" height="9.093" viewBox="0 0 5.961 9.093">
        <path id="Tracé_22129" data-name="Tracé 22129" d="M0,0,3.839,3.839,0,7.679" transform="translate(0.707 0.707)" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="2"/>
        </svg>`;
        // todo : à réactiver en même temps username 
        // titleUsername.innerText = username;
        // todo end : à réactiver en même temps username

        function getOrderCount(){
          const indexOrderCount = html.indexOf('orders_count');

          const ordersCount = html[indexOrderCount + 15];

          return ordersCount;
        }

        // company
        if(data.company.length !== 0 && !data.company.includes('null,') && !data.company.includes('/span>')){
          titleCompany.innerHTML = data.company;
        }

        if(window.location.pathname === '/pages/shopify-quote' || window.location.pathname == '/pages/devis-shopify' || window.location.pathname == '/pages/devis-shopify/' ){
          console.log(data);
          preFillMainFields(data);
        
          const stepOne = document.querySelector('.list-steps.not-connected li:nth-child(1)');

          if(!stepOne.classList.contains('done')){
            const customerFieldForm = document.querySelector('.shopify-section.section');
            const stepSection = document.querySelector('.shopify-section.section-side-steps');
            const formWhenConnected = document.querySelector('.shopify-section.form-user-connected #contact_form');
            const inputsAlreadySet = document.querySelectorAll('.main-infos input')

            for(input of inputsAlreadySet){
              input.setAttribute('readonly', 'readonly');
            }

            const sideStepWhenConnected = document.querySelector('.list-steps.connected');
            const sideStepWhenNotConnected = document.querySelector('.list-steps.not-connected');
            const stepsMobileWhenConnected = document.querySelector('.steps-mobile.connected');
            const stepsMobileWhenDeconnected = document.querySelector('.steps-mobile.deconnected');
    
            customerFieldForm.classList.add('connected');
            stepSection.classList.add('connected');
            formWhenConnected.classList.add('connected');

            stepsMobileWhenConnected.classList.add('active')
            stepsMobileWhenDeconnected.classList.remove('active')
            sideStepWhenConnected.classList.add('active')
            sideStepWhenNotConnected.classList.remove('active')
          }

        }
        
        if(window.location.pathname === "/cart"){
          updatePageCart();
        }
        else{
         // updateStickyCart();
          location.reload();
        }

        // header sticky cart

        function updatePageCart(){
          fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => {
            const count = data.item_count;

            const allTaskText = document.querySelectorAll('.task-text')
            const cartCounts = document.querySelectorAll('.cart-count, .header-cart-count');
            const allEmptyCart = document.querySelectorAll('.empty-cart-container');
            const allFilledCart = document.querySelectorAll('.filled-cart-container');

            cartCounts.forEach(cartCount => {
              cartCount.innerText = count;
            })
            
            const deliveryTop = document.querySelector('.cart-delivery-date.dv');
            deliveryTop.classList.remove('hidden');

            allEmptyCart.forEach(emptyCart => {
              emptyCart.classList.add('hidden');
            })
            allFilledCart.forEach(filledCart => {
              filledCart.classList.remove('hidden');
            })

            if(count === 0){
              allTaskText.forEach(taskText => {
                taskText.innerText = ` ${taskText.dataset.taskSingular}`;
              })
            }
            else{
              allTaskText.forEach(taskText => {
                taskText.innerText = ` ${taskText.dataset.taskPlural}`;
              })
            }
          })
        }

         function updateStickyCart(){
        const data = getAllData(html);

        // /********************this code is for cart update from customer metafield using defind *************************/
        console.log(data)
         console.log(data.customerCartDefine);
        
        var cart_meta_data = data.customerCartDefine.split("'")[0];
        const cartArray = cart_meta_data.split(',').map(item => {
          const [id, quantity] = item.split(':');
          return { id, quantity: parseInt(quantity, 10) };
        });
        console.log("Cart data:", cartArray);

        // Ensure cartArray is valid
        if (!Array.isArray(cartArray) || cartArray.length === 0 || cartArray.some(item => !item.id || isNaN(item.quantity))) {
          console.warn("Invalid cartArray detected, skipping update.");
          return;
        }
      
        if (Array.isArray(cartArray) && cartArray.length > 0) {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              console.log('Current cart from two:', cart);
              const itemsInCart = cart.items;
        
              // Compare cartArray with current cart data
              const itemsToUpdate = cartArray.filter(itemToAdd => {
                const existingItem = itemsInCart.find(itemInCart => itemInCart.id === itemToAdd.id);
                // Check if the item exists and has a mismatched quantity
                if (existingItem) {
                  return existingItem.quantity !== itemToAdd.quantity;
                }
                // If the item doesn't exist, it needs to be added
                return true;
              });
        
              // If there are items to update, send the request
              if (itemsToUpdate.length > 0) {
                console.log('Items to update:', itemsToUpdate);
        
                // Create an updates object with the correct quantities
                const updates = {};
                cartArray.forEach(item => {
                  updates[item.id] = item.quantity;
                });
        
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    updates: updates
                  }),
                }).then(response => response.json())
                .then(data => {
                    const count = data.item_count;
                    const taskText = document.querySelector('.sticky-cart-task-text');
                    const cartCounts = document.querySelectorAll('.header-cart-count');
                    const stickyCartCount = document.querySelector('.sticky-cart-count'); // New: Select sticky cart count
                    const emptyCartContainer = document.querySelector('.empty-cart-container');
                    const filledCartContainer = document.querySelector('.filled-cart-container');
                    const cartItemsWrapper = document.querySelector('.cart-items-wrapper');
                    const totalCheckoutContainer = document.querySelector('.total-checkout-container');
                    const deliveryDateElement = document.querySelector('.cart-delivery-date'); // Reference for insertion
                
                    // ✅ Update all cart count elements
                    cartCounts.forEach(cartCount => {
                        cartCount.innerText = count;
                    });
                
                    // ✅ Update sticky cart count
                    if (stickyCartCount) {
                        stickyCartCount.innerText = count;
                    }

                    console.log("count ahi",count);
              
                
                    if (count === 0) {
                        taskText.innerText = ` ${taskText.dataset.taskSingular}`;
                        emptyCartContainer.classList.remove('hidden');
                        filledCartContainer.classList.add('hidden');
                
                        // Remove existing total price container if present
                        const existingTotalContainer = document.querySelector('.cart-total-container');
                        if (existingTotalContainer) {
                            existingTotalContainer.remove();
                        }
                    } else {
                        const headerLinksCart = document.querySelectorAll('.header-link-cart');
                        headerLinksCart.forEach(linkCart => {
                            linkCart.classList.remove('cart-is-empty');
                        });
                
                        taskText.innerText = ` ${taskText.dataset.taskPlural}`;
                        
                        emptyCartContainer.classList.add('hidden');
                        filledCartContainer.classList.remove('hidden');
                
                        cartItemsWrapper.innerHTML = ""; // Clear previous items
                        
                        let totalPrice = 0;
                        let totalTax = 0;
                       

                
                        data.items.forEach(item => {
                            const taxRate = 0.2; // 20% VAT
                            const taxCoeff = 1 + taxRate;
                            const priceTTC = item.price / 100; // Convert cents to euros
                            const taxAmount = (priceTTC / taxCoeff) * taxRate;
                
                            totalPrice += priceTTC;
                            totalTax += taxAmount;
                
                            let newItem = document.createElement("div");
                            newItem.classList.add("cart-item-container");
                            newItem.setAttribute("data-key", `${item.key}`);
                
                            let image = item.image ? item.image : 'https://cdn.shopify.com/s/files/1/0602/6376/0064/files/Group48095520_d0bf0cae-5590-43a3-9ccc-831beabcc11f-min.png?v=1703143108';
                
                           newItem.innerHTML = `
                            <div class="delete-column">
                                <button class="open-delete" aria-label="Remove item" data-key="${item.key}">
                                    <svg class="svg-open-delete" width="25" height="32" viewBox="0 0 25.761 32.201">
                                        <path class="path-open-delete" d="M13.66,2,12.05,3.61H5.61a1.61,1.61,0,0,0,0,3.22H28.151a1.61,1.61,0,0,0,0-3.22h-6.44L20.1,2ZM5.61,10.05V30.981A3.219,3.219,0,0,0,8.83,34.2h16.1a3.219,3.219,0,0,0,3.22-3.22V10.05Z" transform="translate(-4 -2)"></path>
                                    </svg>
                                </button>
                        
                                <!-- ✅ Delete confirmation popup added -->
                                <div class="cart-popin-delete dv">
                                    <button class="button-popin-delete cancel">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15.516" height="15.516" viewBox="0 0 15.516 15.516">
                                            <path id="icons8-close-window" d="M11.706,9.875,9.875,11.706l5.911,5.921L9.875,23.539l1.831,1.852,5.921-5.921,5.911,5.921,1.852-1.852-5.921-5.911,5.921-5.921L23.539,9.875l-5.911,5.911Z" transform="translate(-9.875 -9.875)"></path>
                                        </svg>
                                        <span>Cancel</span>
                                    </button>
                        
                                    <div class="content-delete">
                                        <span class="content-delete-text">Are you sure you want to remove this item?</span>
                                    </div>
                        
                                    <button class="button-popin-delete confirm">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17.743" height="22.178" viewBox="0 0 17.743 22.178">
                                            <path id="icons8-trash-can" d="M10.654,2,9.545,3.109H5.109a1.109,1.109,0,0,0,0,2.218H20.634a1.109,1.109,0,0,0,0-2.218H16.2L15.089,2ZM5.109,7.545V21.961a2.217,2.217,0,0,0,2.218,2.218H18.416a2.217,2.217,0,0,0,2.218-2.218V7.545Z" transform="translate(-4 -2)"></path>
                                        </svg>  
                                        <span>Confirm</span>
                                    </button>
                                </div>
                            </div>
                        
                            <div class="image-column">
                                <img width="60" height="68" class="line-item-img" src="${image}" loading="lazy" alt="${item.title}">
                            </div>
                        
                            <div class="content-column">
                                <span class="sku">${item.sku}</span>
                                <h4>${item.title}</h4>
                                <div class="url-shopify">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.809" height="15.912" viewBox="0 0 15.809 15.912">
                                      <path id="icons8-internet" d="M9.906,2A7.89,7.89,0,0,0,3.6,5.162H3.582v.02a7.879,7.879,0,0,0-1.5,3.625A8.04,8.04,0,0,0,7,17.2a7.059,7.059,0,0,0,2.907.615.791.791,0,0,0,.787-.794V10.7a.791.791,0,0,0-.791-.791H8.325a.791.791,0,1,1,.009-1.581.784.784,0,0,0,.781-.791V6.743a.791.791,0,0,1,.791-.791H10.7a1.581,1.581,0,0,0,1.581-1.581V4.047a6.331,6.331,0,0,1,3.953,5.858c0,.009,0,.018,0,.028h0a.79.79,0,0,0,1.58-.028q0-.037,0-.074A7.913,7.913,0,0,0,9.906,2ZM3.747,8.49l3.788,3.788v.791a1.581,1.581,0,0,0,1.581,1.581v1.527A6.3,6.3,0,0,1,3.747,8.49Zm9.031.607a.567.567,0,0,0-.5.565v5.647a.4.4,0,0,0,.669.286l1.129-1.073L15.3,17.34a.947.947,0,1,0,1.732-.767L15.8,13.858h1.246a.4.4,0,0,0,.275-.679L13.243,9.252A.56.56,0,0,0,12.778,9.1Z" transform="translate(-2.003 -2)"></path>
                                    </svg>
                                    <span>Undefined Website</span>
                                </div>      
                            </div>
                        
                            <div class="price-column">
                                <div class="item-price-container">
                                    <span class="price-ttc">${priceTTC.toFixed(2)} €</span>
                                    <span class="cart-ttc">inc. VAT</span>
                                    <span class="item-tva">Inc. VAT: ${taxAmount.toFixed(2)} €</span>
                                </div>
                            </div>
                        `;
                        

                
                            cartItemsWrapper.appendChild(newItem);
                        });
                      // Check if your custom container is already there
                      if (totalCheckoutContainer && !totalCheckoutContainer.querySelector('.cart-total-container.injected')) {
                          filledCartContainer.classList.add('dynamic');
                          const customBlock = document.createElement('div');
                          customBlock.classList.add('cart-total-container', 'injected'); // Mark as injected
                          customBlock.innerHTML = `
                              <div class="total_cover">
                                  <span class="total-ttc">TOTAL TTC</span>
                                  <div class="cart-delivery-date mv">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="19.801" height="23.101" viewBox="0 0 19.801 23.101">
                                          <path id="icons8-stopwatch" d="M9.6,1V3.2h6.6V1Zm3.3,3.3a9.918,9.918,0,1,0,7.593,3.558l1.661-1.977L20.469,4.466,18.895,6.339A9.835,9.835,0,0,0,12.9,4.3ZM11.8,7.6H14v4.705a2.2,2.2,0,1,1-2.2,0Z" transform="translate(-3 -1)"></path>
                                      </svg>
                                      <span>Lvraison prévisionnelle :</span>
                                      <span class="delivery-date-value">23/04/2025</span>
                                      <div class="cart-tooltip">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
                                              <path id="icons8-ask-question" d="M0,1V13H5l3,3,3-3h5V1ZM9,12H7V10H9ZM9,9H7V7.971S9,7.309,9,6A1,1,0,0,0,7,6H5a3,3,0,0,1,6,0A3.791,3.791,0,0,1,9,9Z" transform="translate(0 -1)" fill="#000"></path>
                                          </svg>
                                          <div class="cart-tooltip-content">
                                              <p>C'est une date de livraison prévisionnelle qui peut varier en fonction des pré-requis et des communications entre notre équipe et vous.</p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                      
                              <div class="total-price-container">
                                  <div class="price-value">
                                      <span class="price-ttc">${totalPrice.toFixed(2)} €</span>
                                      <span class="cart-ttc">inc. VAT</span>
                                  </div>
                                  <span class="item-tva total">
                                      <span>Inc. VAT: </span>
                                      <span class="tva-total-price">${totalTax.toFixed(2)} €</span>
                                  </span>
                              </div>
                          `;
                      
                          const buttonContainer = totalCheckoutContainer.querySelector('.button-container.cart-button-pay-container');
                      
                          // Insert above the button
                          if (buttonContainer) {
                              totalCheckoutContainer.insertBefore(customBlock, buttonContainer);
                          } else {
                              totalCheckoutContainer.appendChild(customBlock);
                          }
                      }

                      const subtotalElement = document.querySelector('.top-subtotal .price-ttc');
                      const vatElement = document.querySelector('.subtotal-tva-total-price');
                      const vatDataAttr = document.querySelector('.item-tva.subtotal');
                      
                      if (subtotalElement) {
                          subtotalElement.textContent = `${totalPrice.toFixed(2)} €`;
                      }
                      
                      if (vatElement) {
                          vatElement.textContent = `${totalTax.toFixed(2)} €`;
                      }

                    }
                
                    console.log("Updated Cart Data:", data.total_price);
                });



              } else {
                console.log('Cart quantities already match. No update needed.');
                return Promise.resolve(); // Resolve early if no update is needed
              }
            })
            .then(response => response ? response.json() : null)
            .then(data => {
              if (data) {
                console.log('Cart updated successfully!', data);
                // Update the UI if needed
              }
            })
            .catch(error => {
              console.log('Error updating the cart:', error);
            });
        }

          //  var customerEmail = document.querySelector('form#login-ajax-form input[name="email"]').value;
          //  loadCartFromCookie(customerEmail).then(() => {
          //     fetch(window.Shopify.routes.root + 'cart.js')
          //     .then(response => {
          //         if (!response.ok) {
          //             throw new Error('Network response was not ok');
          //         }
          //         return response.json();
          //     })
          //     .then(data => {
          //         const count = data.item_count;
          //         const taskText = document.querySelector('.sticky-cart-task-text');
          //         const cartCounts = document.querySelectorAll('.header-cart-count');

          //         console.log("data.item_count",data.item_count)
      
          //         cartCounts.forEach(cartCount => {
          //             cartCount.innerText = count;
          //         });
      
          //         if (count === 0) {
          //             taskText.innerText = ` ${taskText.dataset.taskSingular}`;
          //         } else {
          //             const headerLinksCart = document.querySelectorAll('.header-link-cart');
          //             headerLinksCart.forEach(linkCart => {
          //                 linkCart.classList.remove('cart-is-empty');
          //             });
      
          //             taskText.innerText = ` ${taskText.dataset.taskPlural}`;
          //         }
          //       // location.reload();
          //       console.log("Cart Data defined:", customerCartDefine);
          //      if (typeof customerCartDefine !== 'undefined' && customerCartDefine) {
          //         console.log("Cart Data defined:", customerCartDefine);
          //         // Perform your actions with customerCartDefine
          //     }
          //     })
          //     .catch(error => console.error('Error fetching cart details:', error));
              
          // });
        }

        function preFillMainFields(data){
          const firstName = document.querySelector('[name="contact[first_name]"');
          const lastName = document.querySelector('[name="contact[last_name]"');
          const email = document.querySelector('[name="contact[email]"');
          const username = document.querySelector('[name="contact[username]"');
          const company = document.querySelector('[name="contact[company]"');
          const urlShopify = document.querySelector('[name="contact[shopify_url]"')
          const cart_Data = document.querySelector('[name="cart_details"')

          if(data.first_name.indexOf('ull,\n') == -1){
            firstName.value = data.first_name
          }else{
            firstName.value = data.last_name
          }
          lastName.value = data.last_name
          email.value = data.customerEmailDefine
          username.value = data.first_name
          cart_Data.value = data.cart_details

          // fixation de l'url Shopify si existant chez l'utilisateur
          if(data.url_de_votre_boutique_shop !== "null"){
            urlShopify.value = data.url_de_votre_boutique_shop
            urlShopify.setAttribute('readonly', 'readonly');
            urlShopify.classList.add('url-fixed');

            // const labelShopifyExist = document.querySelector("label[for='shopify-exist']")
            // labelShopifyExist.click();
          } else{
            
            const radiosContainer = document.querySelector('.radios-shopify-exist');
            radiosContainer.style.display = "block";

            urlShopify.removeAttribute('readonly');
            urlShopify.removeAttribute('style');
            urlShopify.classList.remove('url-fixed');

            const labels = document.querySelectorAll('#contact_form label.url-set, #contact_form legend.url-set');
            labels.forEach(label => label.classList.remove('url-set'));

            document.querySelector('.ct-field.shopify-exist').classList.remove('url-set');

            const inputShopifyExists = document.querySelector('input[name="contact[shopify_exist]"');
            inputShopifyExists.removeAttribute('checked');

            const labelShopifyUrl = document.querySelector('label[for="shopify-url"]');
            labelShopifyUrl.style.display = "none";
          }

          // affichage de la société si remplie dans l'espace client
          company.closest('.ct-field').style.display = "none";
          document.querySelector('.offset-company').style.display = "none";
        }

        function getAllData(text){
            let tableCols = ["first_name", "last_name", "customerEmailDefine", "customerCartDefine", "nom_dutilisateur", "company", "url_de_votre_boutique_shop"];

            let dataFullName = {};

            tableCols.forEach(col => {
              let value = "";

              if(text.indexOf(col) !== -1){
                let i = col === "company" ? text.indexOf(col) + col.length + 3 : text.indexOf(col) + col.length + 4;

                while(text[i] !== '"'){
                  value += text[i];
                  i++;
                }
              } else{
                value = "null";
              }

              dataFullName[col] = value;
            })

            return dataFullName
          }
      }
    })
  }

  function login(email, password) {  
    let data = {
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'customer_login',
      utf8: '✓'
    };
  
    let promise = $.ajax({
      url: '/account/login',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });
  
    return promise;
  }

})
}
function stepReset(step){
  const resetErrorContainer = document.querySelector('.reset-error-container');
  const resetSuccessContainer = document.querySelector('.reset-success-container');

  if(step === 'form'){
    formRP.classList.add('active');
    resetErrorContainer.classList.remove('active');
    resetSuccessContainer.classList.remove('active');
  } 
  else if(step === 'error'){
    formRP.classList.remove('active');
    resetErrorContainer.classList.add('active');
    resetSuccessContainer.classList.remove('active');
  } 
  else if(step === 'success'){
    formRP.classList.remove('active');
    resetErrorContainer.classList.remove('active');
    resetSuccessContainer.classList.add('active');
  }
}


function displayPRErrors(email){
  const PRErrorEmail = document.querySelector('.password-reset-error.error-email');

  if(email.length === 0){
    PRErrorEmail.innerText = PRErrorEmail.dataset.requireField;
    formRPSuccess = false;
    inputRPEmail.classList.add('error');
  } else if(!email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
    PRErrorEmail.innerText = PRErrorEmail.dataset.invalidField;
    formRPSuccess = false;
    inputRPEmail.classList.add('error');
  } else{
    PRErrorEmail.innerText = "";
    formRPSuccess = true;
    inputRPEmail.classList.remove('error');
  }
}

function displayLoginErrors(email, password){
  const loginErrorEmail = document.querySelector('.login-error.error-email:not(.error-email-popup)');
  const loginErrorPassword = document.querySelector('.login-error.error-password:not(.error-password-popup)');

  if(email.length === 0){
    loginErrorEmail.innerText = loginErrorEmail.dataset.requireField;
    formSuccess = false;
    inputLoginEmail.classList.add('error');
  } else if(!email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
    loginErrorEmail.innerText = loginErrorEmail.dataset.invalidField;
    formSuccess = false;
    inputLoginEmail.classList.add('error');
  } else{
    loginErrorEmail.innerText = "";
    formSuccess = true;
    inputLoginEmail.classList.remove('error');
  }

  if(password.length === 0){
    loginErrorPassword.innerText = loginErrorPassword.dataset.requireField;
    formSuccess = false;
    inputLoginPassword.classList.add('error');
  } else{
    loginErrorPassword.innerText = "";
    inputLoginPassword.classList.remove('error');
  }

}

// sticky cart on Desktop

const headerCartLinkDesktop = document.querySelector('.header__icons .header-link-cart');
const stickyCartDesktop = document.querySelector('.sticky-cart.header-desktop-sticky-cart');
if(headerCartLinkDesktop){
headerCartLinkDesktop.addEventListener('click', (e) => {
    stickyCartDesktop.classList.toggle('active');
    headerCartLinkDesktop.classList.toggle('active');

    if(stickyCartDesktop.classList.contains('active')){
      gsap.to(".emoji-sticky-desktop", {
        duration: 3, 
        motionPath:{
          path: "#sticky-desktop #path-cart-anim",
          align: "#sticky-desktop #path-cart-anim",
          alignOrigin: [0.5, 0.5],
          start:0.25,
          end:-0.75
        }
      });
    }
});
}

// sticky cart on Mobile

const headerMobileBtnCart = document.querySelector('.header-mobile-container .header-link-cart');
const stickyCartMobile = document.querySelector('.sticky-cart.header-mobile-sticky-cart');
if(headerMobileBtnCart){
headerMobileBtnCart.addEventListener('click', () => {
  stickyCartMobile.classList.add('active');
  stickyCartMobile.classList.remove('not-active');

  gsap.to(".emoji-sticky-mobile", {
    duration: 3, 
    motionPath:{
      path: "#sticky-mobile #path-cart-anim",
      align: "#sticky-mobile #path-cart-anim",
      alignOrigin: [0.5, 0.5],
      start:0.25,
      end:-0.75
    }
  });
})
}
if(!window.location.pathname.includes('/cart')){
  const allBackToNavigation = document.querySelectorAll('.header-mobile-sticky-cart .cart-btn-container button');

  allBackToNavigation.forEach(button => {
    button.addEventListener('click', () => {
      stickyCartMobile.classList.remove('active');
      stickyCartMobile.classList.add('not-active');
    })
  })
}

// login mobile

const headerMobileContainer = document.querySelector('.header-mobile-container');
const globalLinkLoginMobile = document.querySelector('.header-mobile-container .header-link-account');
const btnSubmitMobile = document.querySelector('#login-ajax-form-mobile button[type="submit"]');
const btnSubmitRPMobile = document.querySelector('#password-reset-ajax-form-mobile button[type="submit"]');


// login slider

const sliderLoginMobile = document.querySelector('.header-mobile-container .account-slider-moving');
const btnPasswordMobile = document.querySelector('.header-mobile-container .reset-password-link:not(.popup-reset-password-link) > span');
const btnBackLoginMobile = document.querySelector('.header-mobile-container .back-login > span');
const inputLoginEmailMobile = document.querySelector('#login_email_mobile');
const inputLoginPasswordMobile = document.querySelector('#login_password_mobile');
let indexSliderMobile = 0;

const inputResetPasswordMobile = document.querySelector('#password_reset_email_mobile');

const loginErrorEmailMobile = document.querySelector('.header-mobile-container .login-error.error-email');
const loginErrorPasswordMobile = document.querySelector('.header-mobile-container .login-error.error-password');

let formSuccessMobile = false;
if(inputLoginEmailMobile){
inputLoginEmailMobile.addEventListener('input', () => {
  if(loginErrorEmailMobile.innerText.length !== 0){
    displayLoginErrorsMobile(inputLoginEmailMobile.value, inputLoginPasswordMobile.value);
  }
})
inputLoginPasswordMobile.addEventListener('input', function(){
  if(loginErrorPasswordMobile.innerText.length !== 0){
    displayLoginErrorsMobile(inputLoginEmailMobile.value, inputLoginPasswordMobile.value);
  }

  const eyeBtnsConnexionMobile = document.querySelectorAll('.eye-btn-connexion')[1];

  if(this.value === ""){
    eyeBtnsConnexionMobile.style.display = "none";
  } else{
    eyeBtnsConnexionMobile.style.display = "inline-flex";
  }
})

btnPasswordMobile.addEventListener('click', () => {
  indexSliderMobile = 1;
  inputResetPasswordMobile.value = inputLoginEmailMobile.value;
  updateSliderLoginMobile(indexSliderMobile);
  setTimeout(() => {
    inputResetPasswordMobile.focus();
  }, 300);
})

btnBackLoginMobile.addEventListener('click', () => {
  indexSliderMobile = 0;
  updateSliderLoginMobile(indexSliderMobile);
  setTimeout(() => {
    inputLoginEmailMobile.focus();
    const passwordResetForm = document.querySelector('#password-reset-ajax-form-mobile');
    if (passwordResetForm) passwordResetForm.classList.add('active');

    const resetSuccessContainer = document.querySelector('.reset-success-container');
    if (resetSuccessContainer) resetSuccessContainer.classList.remove('active');
  }, 300);
})
}

function updateSliderLoginMobile(index){
  sliderLoginMobile.style.transform = `translateX(-${index}00%)`;
}

// ajax reset password

const formRPMobile = document.querySelector('#password-reset-ajax-form-mobile');
const RPErrorEmailMobile = document.querySelector('.header-mobile-container .password-reset-error.error-email');
const inputRPEmailMobile = document.querySelector('#password_reset_email_mobile');
if(inputRPEmailMobile){
inputRPEmailMobile.addEventListener('input', () => {
  if(RPErrorEmailMobile.innerText.length !== 0){
    displayPRErrorsMobile(inputRPEmailMobile.value);
  }
})
}

let formRPSuccessMobile = false;

const backToFormBtnMobile = document.querySelector('.header-mobile-container .back-to-form');
if(backToFormBtnMobile){
backToFormBtnMobile.addEventListener('click', () => {
  stepReset('form');
  inputRPEmailMobile.value = "";
  inputRPEmailMobile.focus();
})

}

if(formRPMobile){
formRPMobile.addEventListener('submit', (e) => {
  e.preventDefault();

  const email = inputRPEmailMobile.value;
  const loaderSubmit = document.querySelector('.header-mobile-container .rp-loader-submit:not(.rp-loader-submit-popup)');
  console.log(email)
  displayPRErrorsMobile(email);

   function maskEmail(email, threshold = 10) {
    const match = email.match(/^([^@]+)@(.+)$/);
    if (!match) return email; // fallback if invalid email

    const localPart = match[1];
    const domain = match[2];

    if (localPart.length <= threshold) {
      return `${localPart}@${domain}`;
    } else {
      return `${localPart.slice(0, threshold)}…@${domain}`;
    }
  }

  if(formRPSuccessMobile){
    loaderSubmit.classList.add('active');

    passwordReset(email).done(function (html) {
      loaderSubmit.classList.add('active');

      if(html.indexOf('id="RecoverEmail-email-error"') !== -1){
        loaderSubmit.classList.remove('active');

        stepResetMobile('error');
      
        document.querySelector('.email-reset.error').innerText = maskEmail(email);
      }
      else{
        loaderSubmit.classList.remove('active');

        stepResetMobile('success');
        document.querySelector('.email-reset.success.mobile_reset').innerText = maskEmail(email);
      }
    })
    .fail(function (xhr) {
        loaderSubmit.classList.remove('active');

        if (xhr.status === 429) {
          // Show too many attempts error
          document.querySelector('#password-reset-ajax-form-mobile .too_many_attempt_error').style.display = 'inline';

          // Hide submit button
          const submitBtn = document.querySelector('#password-reset-ajax-form-mobile button[type="submit"]');
          if (submitBtn) {
            submitBtn.style.display = 'none';
          }

        } else {
          stepReset('error');
          document.querySelector('.email-reset.error').innerText =
            "Something went wrong. Please try again.";
        }
      });
  }

  function passwordReset(email) {
    let data = {
      'email': email,
      form_type: 'recover_customer_password',
      utf8: '✓'
    };
  
    let promise = $.ajax({
      url: '/account/recover',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });
  
    return promise;
  }

})
}

// ajax login

const formLoginMobile = document.querySelector('#login-ajax-form-mobile');
if(formLoginMobile){
formLoginMobile.addEventListener('submit', (e) => {
  e.preventDefault();
 
  const loaderSubmit = document.querySelector('.header-mobile-container .login-loader-submit');
  const errorLogin = document.querySelector('.header-mobile-container .error-login');
  const email = inputLoginEmailMobile.value;
  const password = inputLoginPasswordMobile.value;
  const navAccountText = document.querySelector('.navbar-block > span')

  const titleFullName = document.querySelector('.block-title-deconnexion h3 .header-full-name');
  const titleCompany = document.querySelector('.block-title-deconnexion h3 .header-mobile-company');
  const titleUsername = document.querySelector('.block-title-deconnexion h4');

  displayLoginErrorsMobile(email, password);

  errorLogin.classList.remove('active');

  if(formSuccessMobile){
    loaderSubmit.classList.add('active');

    login(email, password).done(function (html) {
      if (html.indexOf('deleted') !== -1) {
        $.ajax({
          url:'/account/logout',
          async:true,
        })
        
        errorLogin.classList.add('active');
        loaderSubmit.classList.remove('active');
        inputLoginPasswordMobile.blur();

        return;
      }

      if (html.indexOf('<div class="errors">') !== -1) {
        errorLogin.classList.add('active');

        loaderSubmit.classList.remove('active');
      } else {
        const headerLinkCart = document.querySelector('.header-link-cart');
        headerLinkCart.classList.add('connected');
  
        accountContainer.classList.remove('active');
  
        navbarBlock.classList.add('connected');
        navbarBlock.classList.remove('active');
        navAccountText.innerHTML = navAccountText.dataset.myAccount;
  
        globalLinkLogin.removeEventListener('click', preventForm);

        loaderSubmit.classList.remove('active');

        toggleMenu();

        headerMobileContainer.classList.add('connected');

        const data = getAllData(html);

        const menuMobileMyOrders = document.querySelector('.header-my-account.orders');

        const ordersCount = getOrderCount();

        if(ordersCount == "0"){
          menuMobileMyOrders.style.display = "none";
        } else{
          menuMobileMyOrders.style.display = "block";
        }
        openHeaderMobileToggleAccount()
        // let userNamevalue = ""; // Declare the variable before using it
        const fullName = data.first_name + " " + data.last_name;
        const username = data.username;

        if(fullName.length > 12) {
          userNamevalue = fullName.slice(0, 12)
        }else if(fullName.length < 8) {
          var lengthRemain = 8 - fullName.length;
          var randomNumbers = ['12345678', '87654321', '13572468', '24681357'];
          var currentTime = Date.now();
          var randomIndex = currentTime % randomNumbers.length;
          var randomPadding = randomNumbers[randomIndex].slice(0, lengthRemain);
          userNamevalue = fullName+randomPadding;
        }

        CF.customer.set("nom_dutilisateur", userNamevalue);

        titleFullName.innerHTML = `<span>${fullName}</span><svg xmlns="http://www.w3.org/2000/svg" width="5.961" height="9.093" viewBox="0 0 5.961 9.093">
        <path id="Tracé_22129" data-name="Tracé 22129" d="M0,0,3.839,3.839,0,7.679" transform="translate(0.707 0.707)" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="2"/>
        </svg>`;
        // todo : à réactiver en même temps username 
        // titleUsername.innerText = username;
        // todo end : à réactiver en même temps username 

        function getOrderCount(){
          const indexOrderCount = html.indexOf('orders_count');

          const ordersCount = html[indexOrderCount + 15];

          return ordersCount;
        }

        // company
        if(window.location.pathname === "/pages/shopify-quote" || window.location.pathname == '/pages/devis-shopify' || window.location.pathname == '/pages/devis-shopify/'){
          company.closest('.ct-field').style.display = "none";
          document.querySelector('.offset-company').style.display = "none";
        }

        if(window.location.pathname === "/pages/shopify-quote" || window.location.pathname == '/pages/devis-shopify' || window.location.pathname == '/pages/devis-shopify/'){
          preFillMainFields(data);

          const stepOne = document.querySelector('.list-steps.not-connected li:nth-child(1)');

          if(!stepOne.classList.contains('done')){
            const customerFieldForm = document.querySelector('.shopify-section.section');
            const stepSection = document.querySelector('.shopify-section.section-side-steps');
            const formWhenConnected = document.querySelector('.shopify-section.form-user-connected #contact_form');
            const inputsAlreadySet = document.querySelectorAll('.main-infos input')

            for(input of inputsAlreadySet){
              input.setAttribute('readonly', 'readonly');
            }
    
            customerFieldForm.classList.add('connected');
            stepSection.classList.add('connected');
            formWhenConnected.classList.add('connected');

            const sideStepWhenConnected = document.querySelector('.list-steps.connected');
            const sideStepWhenNotConnected = document.querySelector('.list-steps.not-connected');
            const stepsMobileWhenConnected = document.querySelector('.steps-mobile.connected');
            const stepsMobileWhenDeconnected = document.querySelector('.steps-mobile.deconnected');

            stepsMobileWhenConnected.classList.add('active')
            stepsMobileWhenDeconnected.classList.remove('active')
            sideStepWhenConnected.classList.add('active')
            sideStepWhenNotConnected.classList.remove('active')
          }
        }

        if(window.location.pathname === "/cart"){
          updatePageCart();
        }
        else{
          // updateStickyCart();
          location.reload();
        }

        // header sticky cart
        
        function updatePageCart(){
          fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => {
            const count = data.item_count;

            const allTaskText = document.querySelectorAll('.task-text')
            const cartCounts = document.querySelectorAll('.cart-count, .header-cart-count');
            const allEmptyCart = document.querySelectorAll('.empty-cart-container');
            const allFilledCart = document.querySelectorAll('.filled-cart-container');

            cartCounts.forEach(cartCount => {
              cartCount.innerText = count;
            })

            const deliveryTop = document.querySelector('.cart-delivery-date.dv');
            deliveryTop.classList.remove('hidden');

            allEmptyCart.forEach(emptyCart => {
              emptyCart.classList.add('hidden');
            })
            allFilledCart.forEach(filledCart => {
              filledCart.classList.remove('hidden');
            })

            if(count === 0){
              allTaskText.forEach(taskText => {
                taskText.innerText = ` ${taskText.dataset.taskSingular}`;
              })
            }
            else{
              allTaskText.forEach(taskText => {
                taskText.innerText = ` ${taskText.dataset.taskPlural}`;
              })
            }

          })
        }

        function updateStickyCart(){
         const data = getAllData(html);

        /********************this code is for cart update from customer metafield using defind *************************/
        console.log(data)
         console.log(data.customerCartDefine);
        
        var cart_meta_data = data.customerCartDefine.split("'")[0];
        const cartArray = cart_meta_data.split(',').map(item => {
          const [id, quantity] = item.split(':');
          return { id, quantity: parseInt(quantity, 10) };
        });
        console.log("Cart data:", cartArray);

       // Ensure cartArray is valid
        if (!Array.isArray(cartArray) || cartArray.length === 0 || cartArray.some(item => !item.id || isNaN(item.quantity))) {
          console.warn("Invalid cartArray detected, skipping update.");
          return;
        }
      
        if (Array.isArray(cartArray) && cartArray.length > 0) {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              console.log('Current cart from two:', cart);
              const itemsInCart = cart.items;
        
              // Compare cartArray with current cart data
              const itemsToUpdate = cartArray.filter(itemToAdd => {
                const existingItem = itemsInCart.find(itemInCart => itemInCart.id === itemToAdd.id);
                // Check if the item exists and has a mismatched quantity
                if (existingItem) {
                  return existingItem.quantity !== itemToAdd.quantity;
                }
                // If the item doesn't exist, it needs to be added
                return true;
              });
        
              // If there are items to update, send the request
              if (itemsToUpdate.length > 0) {
                console.log('Items to update:', itemsToUpdate);
        
                // Create an updates object with the correct quantities
                const updates = {};
                cartArray.forEach(item => {
                  updates[item.id] = item.quantity;
                });
        
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    updates: updates
                  }),
                }).then(response => response.json())
                .then(data => {
                    const count = data.item_count;
                    console.log("Cart Count:", count);
                
                    const taskText = document.querySelector('.sticky-cart-task-text');
                    const cartCounts = document.querySelectorAll('.header-cart-count .header-mobile-count');
                
                    cartCounts.forEach(cartCount => {
                        cartCount.innerText = `${count}`;
                    });
                
                    if (count === 0) {
                        taskText.innerText = ` ${taskText.dataset.taskSingular}`;
                    } else {
                        const headerLinksCart = document.querySelectorAll('.header-link-cart');
                        headerLinksCart.forEach(linkCart => {
                            linkCart.classList.remove('cart-is-empty');
                        });
                
                        taskText.innerText = ` ${taskText.dataset.taskPlural}`;
                    }
                
                    const stickyCartCount = document.querySelector('.header-mobile-sticky-cart .sticky-cart-count');
                    const emptyCartContainer = document.querySelector('.header-mobile-sticky-cart .empty-cart-container');
                    const filledCartContainer = document.querySelector('.header-mobile-sticky-cart .filled-cart-container');
                    const totalCheckoutContainerMobile = document.querySelector('.header-mobile-sticky-cart .total-checkout-container');
                    const deliveryDateElement = document.querySelector('.header-mobile-sticky-cart .cart-delivery-date');
                    const mobileCartCover = document.querySelector('.header-mobile-sticky-cart .mobile_cart_cover');
                    const cartCountMobile = document.querySelector('.header-mobile-sticky-cart .cart-count');
                    
                
                    console.log("Elements Check:", {
                        stickyCartCount,
                        emptyCartContainer,
                        filledCartContainer,
                        totalCheckoutContainerMobile,
                        deliveryDateElement,
                        mobileCartCover,
                        cartCountMobile
                    });
                
                    if (stickyCartCount) stickyCartCount.innerText = count;
                    if (cartCountMobile) cartCountMobile.innerText = count;
                
                    if (count === 0) {
                        console.log("Cart is empty, updating UI...");
                        emptyCartContainer?.classList.remove('hidden');
                        filledCartContainer?.classList.add('hidden');
                        mobileCartCover.innerHTML = "";
                    } else {
                        console.log("Cart has items, updating UI...");
                        emptyCartContainer?.classList.add('hidden');
                        filledCartContainer?.classList.remove('hidden');
                        mobileCartCover.innerHTML = "";
                
                        let totalPrice = 0;
                        let totalTax = 0;
                
                        data.items.forEach(item => {
                            const taxRate = 0.2;
                            const taxCoeff = 1 + taxRate;
                            const priceTTC = item.price / 100;
                            const taxAmount = (priceTTC / taxCoeff) * taxRate;
                            totalPrice += priceTTC;
                            totalTax += taxAmount;
                
                            console.log("Item Processed:", { 
                                title: item.title, 
                                priceTTC, 
                                taxAmount 
                            });
                
                            let newItem = document.createElement("div");
                            newItem.classList.add("cart-item-container");
                            newItem.setAttribute("data-key", item.key);
                            
                            let image = item.image ? item.image : 'https://cdn.shopify.com/s/files/1/0602/6376/0064/files/Group48095520_d0bf0cae-5590-43a3-9ccc-831beabcc11f-min.png?v=1703143108';
                
                            newItem.innerHTML = `
                                <div class="delete-column">
                                    <button class="open-delete" aria-label="Supprimer le produit du panier et de la commande" data-key="${item.key}">
                                        <svg class="svg-open-delete" xmlns="http://www.w3.org/2000/svg" width="25.761" height="32.201" viewBox="0 0 25.761 32.201">
                                            <path class="path-open-delete" id="icons8-trash-can" d="M13.66,2,12.05,3.61H5.61a1.61,1.61,0,0,0,0,3.22H28.151a1.61,1.61,0,0,0,0-3.22h-6.44L20.1,2ZM5.61,10.05V30.981A3.219,3.219,0,0,0,8.83,34.2h16.1a3.219,3.219,0,0,0,3.22-3.22V10.05Z" transform="translate(-4 -2)"></path>
                                        </svg>
                                    </button>
                                </div>
                
                                <div class="image-column">
                                    <img width="60" height="68" class="line-item-img" src="${image}" loading="lazy" alt="${item.title}">
                                </div>
                
                                <div class="content-column">
                                    <span class="sku">${item.sku}</span>
                                    <h4>${item.title}</h4>
                                    <div class="url-shopify">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15.809" height="15.912" viewBox="0 0 15.809 15.912">
                                          <path id="icons8-internet" d="M9.906,2A7.89,7.89,0,0,0,3.6,5.162H3.582v.02a7.879,7.879,0,0,0-1.5,3.625A8.04,8.04,0,0,0,7,17.2a7.059,7.059,0,0,0,2.907.615.791.791,0,0,0,.787-.794V10.7a.791.791,0,0,0-.791-.791H8.325a.791.791,0,1,1,.009-1.581.784.784,0,0,0,.781-.791V6.743a.791.791,0,0,1,.791-.791H10.7a1.581,1.581,0,0,0,1.581-1.581V4.047a6.331,6.331,0,0,1,3.953,5.858c0,.009,0,.018,0,.028h0a.79.79,0,0,0,1.58-.028q0-.037,0-.074A7.913,7.913,0,0,0,9.906,2ZM3.747,8.49l3.788,3.788v.791a1.581,1.581,0,0,0,1.581,1.581v1.527A6.3,6.3,0,0,1,3.747,8.49Zm9.031.607a.567.567,0,0,0-.5.565v5.647a.4.4,0,0,0,.669.286l1.129-1.073L15.3,17.34a.947.947,0,1,0,1.732-.767L15.8,13.858h1.246a.4.4,0,0,0,.275-.679L13.243,9.252A.56.56,0,0,0,12.778,9.1Z" transform="translate(-2.003 -2)"></path>
                                        </svg>
                                        <span>Undefined Website</span>
                                    </div>      
                                </div>
                
                                <div class="price-column">
                                    <div class="item-price-container">
                                        <span class="price-ttc">${priceTTC.toFixed(2)} €</span>
                                        <span class="cart-ttc">inc. VAT</span>
                                        <span class="item-tva">Inc. VAT: ${taxAmount.toFixed(2)} €</span>
                                    </div>
                                </div>`;
                
                            mobileCartCover.appendChild(newItem);
                        });
                
                        console.log("Total Price:", totalPrice);
                        console.log("Total Tax:", totalTax);
                      
                
                        const existingTotalContainer = document.querySelector('.header-mobile-sticky-cart .cart-total-container');
                        if (existingTotalContainer) {
                            console.log("Removing old total price container...");
                            existingTotalContainer.remove();
                        }
                
                        // Create total price container element
                          const totalPriceContainerMobile = document.createElement("div");
                          totalPriceContainerMobile.classList.add("cart-total-container", "cart-total-container-mobile");
                          
                          totalPriceContainerMobile.innerHTML = `
                              <div class="total_cover">
                                  <span class="total-ttc">TOTAL with VAT</span>
                              </div>
                              <div class="total-price-container">
                                  <div class="price-value">
                                      <span class="price-ttc" data-currency="€">${totalPrice.toFixed(2)} €</span>
                                      <span class="cart-ttc">inc. VAT</span>
                                  </div>
                                  <span class="item-tva total">
                                      <span>Inc. VAT : </span>
                                      <span class="tva-total-price" data-currency="€">${totalTax.toFixed(2)} €</span>
                                  </span>
                              </div>
                              <div class="cart-delivery-date mv mobile-side">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="19.801" height="23.101" viewBox="0 0 19.801 23.101">
                                      <path d="M9.6,1V3.2h6.6V1Zm3.3,3.3a9.918,9.918,0,1,0,7.593,3.558l1.661-1.977L20.469,4.466,18.895,6.339A9.835,9.835,0,0,0,12.9,4.3ZM11.8,7.6H14v4.705a2.2,2.2,0,1,1-2.2,0Z" transform="translate(-3 -1)"></path>
                                  </svg>
                                  <span>Estimated Delivery :</span>
                                  <span class="delivery-date-value">21/04/2025</span>
                                  <div class="cart-tooltip">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
                                          <path d="M0,1V13H5l3,3,3-3h5V1ZM9,12H7V10H9ZM9,9H7V7.971S9,7.309,9,6A1,1,0,0,0,7,6H5a3,3,0,0,1,6,0A3.791,3.791,0,0,1,9,9Z" transform="translate(0 -1)" fill="#000"></path>
                                      </svg>
                                      <div class="cart-tooltip-content">
                                          <p>This is an Estimated Date of Delivery which may vary according to the prerequisites and the communications between our Team and you.</p>
                                      </div>
                                  </div>
                              </div>
                          `;
                          
                          // Make sure container exists
                          if (totalCheckoutContainerMobile) {
                              const discountContainer = totalCheckoutContainerMobile.querySelector('.discount-container');
                          
                              if (discountContainer) {
                                  // Prevent duplicate insertion
                                  if (!totalCheckoutContainerMobile.querySelector('.cart-total-container-mobile')) {
                                      discountContainer.insertAdjacentElement('afterend', totalPriceContainerMobile);
                                      console.log("✅ Inserted after .discount-container inside .total-checkout-container");
                                  } else {
                                      console.log("⛔ .cart-total-container-mobile already exists. Skipping insert.");
                                  }
                              } else {
                                  console.warn("⚠️ .discount-container not found inside .total-checkout-container");
                              }
                          } else {
                              console.warn("⚠️ .total-checkout-container not found");
                          }

                          const subtotalElement = document.querySelector('.header-mobile-sticky-cart .top-subtotal .price-ttc');
                          const vatElement = document.querySelector('.header-mobile-sticky-cart .subtotal-tva-total-price');
                          const vatDataAttr = document.querySelector('.header-mobile-sticky-cart .item-tva.subtotal');
                          
                          if (subtotalElement) {
                              subtotalElement.textContent = `${totalPrice.toFixed(2)} €`;
                          }
                          
                          if (vatElement) {
                              vatElement.textContent = `${totalTax.toFixed(2)} €`;
                          }


                    }
                
                    console.log("Updated Cart Data:", data.total_price);
                });

              } else {
                console.log('Cart quantities already match. No update needed.');
                return Promise.resolve(); // Resolve early if no update is needed
              }
            })
            .then(response => response ? response.json() : null)
            .then(data => {
              if (data) {
                console.log('Cart updated successfully!', data);
                // Update the UI if needed
              }
            })
            .catch(error => {
              console.log('Error updating the cart:', error);
            });
        } else {
          console.log("No valid cart data found.");
        }
          //  loadCartFromCookie(customerEmail).then(() => {
          //    fetch(window.Shopify.routes.root + 'cart.js')
          //     .then(response => response.json())
          //     .then(data => {
          //       const count = data.item_count;
                
          //       const taskText = document.querySelector('.sticky-cart-task-text');
          //       const cartCounts = document.querySelectorAll('.header-cart-count');
    
          //       cartCounts.forEach(cartCount => {
          //         cartCount.innerText = count;
          //       })
    
          //       if(count === 0){
          //         taskText.innerText = ` ${taskText.dataset.taskSingular}`;
          //       }
          //       else{
          //         const headerLinksCart = document.querySelectorAll('.header-link-cart');
    
          //         headerLinksCart.forEach(linkCart => {
          //           linkCart.classList.remove('cart-is-empty')
          //         });
    
          //         taskText.innerText = ` ${taskText.dataset.taskPlural}`;
          //       }
          //        // location.reload()
          //     })
          // });
        }

        function preFillMainFields(data){
          const firstName = document.querySelector('[name="contact[first_name]"');
          const lastName = document.querySelector('[name="contact[last_name]"');
          const email = document.querySelector('[name="contact[email]"');
          const username = document.querySelector('[name="contact[username]"');
          const company = document.querySelector('[name="contact[company]"');
          const urlShopify = document.querySelector('[name="contact[shopify_url]"');

          company.closest('.ct-field').style.display = "none";
          $('.offset-company').hide();

          if(data.first_name.indexOf('ull,\n') == -1){
            firstName.value = data.first_name
          }else{
            firstName.value = data.last_name
          }
          lastName.value = data.last_name
          email.value = data.customerEmailDefine
          cartData.value = JSON.stringify(data.customerCartDefine);
          username.value = data.first_name

          console.log(data);
          
          // fixation de l'url Shopify si existant chez l'utilisateur
          if(data.url_de_votre_boutique_shop !== "null"){
            urlShopify.value = data.url_de_votre_boutique_shop
            urlShopify.setAttribute('readonly', 'readonly');
            urlShopify.classList.add('url-fixed');

            // const labelShopifyExist = document.querySelector("label[for='shopify-exist']")
            // labelShopifyExist.click();
          } else{
            
            const radiosContainer = document.querySelector('.radios-shopify-exist');
            radiosContainer.style.display = "block";

            urlShopify.removeAttribute('readonly');
            urlShopify.removeAttribute('style');
            urlShopify.classList.remove('url-fixed');

            const labels = document.querySelectorAll('#contact_form label.url-set, #contact_form legend.url-set');
            labels.forEach(label => label.classList.remove('url-set'));

            document.querySelector('.ct-field.shopify-exist').classList.remove('url-set');

            const inputShopifyExists = document.querySelector('input[name="contact[shopify_exist]"');
            inputShopifyExists.removeAttribute('checked');

            const labelShopifyUrl = document.querySelector('label[for="shopify-url"]');
            labelShopifyUrl.style.display = "none";
          }

          // affichage de la société si remplie dans l'espace client
          if(data.company.length !== 0 && !data.company.includes('null,') && !data.company.includes('/span>')){
            company.value = data.company;
          } else{
            company.closest('.ct-field').style.display = "none";
          }
        }

        function getAllData(text){
          let tableCols = ["first_name", "last_name", "customerEmailDefine", "customerCartDefine", "nom_dutilisateur", "company", "url_de_votre_boutique_shop"];

            let dataFullName = {};

            tableCols.forEach(col => {
              let value = "";

              if(text.indexOf(col) !== -1){
                let i = col === "company" ? text.indexOf(col) + col.length + 3 : text.indexOf(col) + col.length + 4;

                while(text[i] !== '"'){
                  value += text[i];
                  i++;
                }
              } else{
                value = "null";
              }

              dataFullName[col] = value;
            })

            return dataFullName
        }
      }
    })
  }


  function login(email, password) {  
    let data = {
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'customer_login',
      utf8: '✓'
    };
  
    let promise = $.ajax({
      url: '/account/login',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });
  
    return promise;
  }

})
}

function stepResetMobile(step){
  const resetErrorContainer = document.querySelector('.header-mobile-container .reset-error-container');
  const resetSuccessContainer = document.querySelector('.header-mobile-container .reset-success-container');

  if(step === 'form'){
    formRPMobile.classList.add('active');
    resetErrorContainer.classList.remove('active');
    resetSuccessContainer.classList.remove('active');
  } else if(step === 'error'){
    formRPMobile.classList.remove('active');
    resetErrorContainer.classList.add('active');
    resetSuccessContainer.classList.remove('active');
  } else if(step === 'success'){
    formRPMobile.classList.remove('active');
    resetErrorContainer.classList.remove('active');
    resetSuccessContainer.classList.add('active');
  }
}

function displayPRErrorsMobile(email){
  const PRErrorEmail = document.querySelector('.header-mobile-container .password-reset-error.error-email');

  if(email.length === 0){
    PRErrorEmail.innerText = PRErrorEmail.dataset.requireField;
    formRPSuccessMobile = false;
    inputRPEmailMobile.classList.add('error');
  } else if(!email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
    PRErrorEmail.innerText = PRErrorEmail.dataset.invalidField;
    formRPSuccessMobile = false;
    inputRPEmailMobile.classList.add('error');
  } else{
    PRErrorEmail.innerText = "";
    formRPSuccessMobile = true;
    inputRPEmailMobile.classList.remove('error');
  }
}

function displayLoginErrorsMobile(email, password){
  const loginErrorEmail = document.querySelector('.header-mobile-container .login-error.error-email');
  const loginErrorPassword = document.querySelector('.header-mobile-container .login-error.error-password');

  if(email.length === 0){
    loginErrorEmail.innerText = loginErrorEmail.dataset.requireField;
    formSuccessMobile = false;
    inputLoginEmailMobile.classList.add('error');
  } else if(!email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
    loginErrorEmail.innerText = loginErrorEmail.dataset.invalidField;
    formSuccessMobile = false;
    inputLoginEmailMobile.classList.add('error');
  } else{
    loginErrorEmail.innerText = "";
    formSuccessMobile = true;
    inputLoginEmailMobile.classList.remove('error');
  }

  if(password.length === 0){
    loginErrorPassword.innerText = loginErrorPassword.dataset.requireField;
    formSuccessMobile = false;
    inputLoginPasswordMobile.classList.add('error');
  } else{
    loginErrorPassword.innerText = "";
    inputLoginPasswordMobile.classList.remove('error');
  }

}


// header menu responsive

const menuBtn = document.querySelector('.menu-btn');

let showMenu = false;
// let scrollValueBeforeHeaderToggle;

let togglePermission = true;
if(menuBtn){
menuBtn.addEventListener('click', toggleMenu);
}
const header = document.querySelector('header.header');

function toggleMenu() {
  if(togglePermission){
    if (!showMenu) {
      menuBtn.classList.add('active');
      showMenu = true;
      headerMobileContainer.classList.add('active');
      headerMobileContainer.classList.remove('not-active');

      // scrollValueBeforeHeaderToggle = window.scrollY;
      document.body.classList.add('header-menu-active');
      // document.documentElement.classList.add('header-menu-active');

    }
    else {
      menuBtn.classList.remove('active');
      showMenu = false;
      headerMobileContainer.classList.remove('active');
      headerMobileContainer.classList.add('not-active');

      if(stickyCartMobile.classList.contains('active')){
        stickyCartMobile.classList.add('not-active');
        stickyCartMobile.classList.remove('active');
      }

      // document.documentElement.classList.remove('header-menu-active');
      document.body.classList.remove('header-menu-active');
      // window.scroll({
      //   top: scrollValueBeforeHeaderToggle,
      //   behavior: "instant"
      // });

      setTimeout(() => {
        indexSliderMobile = 0;
        updateSliderLoginMobile(indexSliderMobile);
        resetForm();
      }, 300);
    }

    togglePermission = false;

    setTimeout(() => {
      togglePermission = true;
    }, 400);
  }
}

function resetForm(){
  const loginErrorEmail = document.querySelector('.header-mobile-container .login-error.error-email');
  const loginErrorPassword = document.querySelector('.header-mobile-container .login-error.error-password');
  const PRErrorEmail = document.querySelector('.header-mobile-container .password-reset-error.error-email');

  loginErrorEmail.innerText = "";
  loginErrorPassword.innerText = "";
  PRErrorEmail.innerText = "";

  inputLoginEmailMobile.value = "";
  inputLoginPasswordMobile.value = "";
  inputRPEmailMobile.value = "";

  inputLoginEmailMobile.classList.remove('error');
  inputLoginPasswordMobile.classList.remove('error');
  inputRPEmailMobile.classList.remove('error');
}

// deconnexion ajax
if (window.location.pathname === "/account/login") {
    // Add 'active' class to .header-mobile-container and .menu-btn
    const headerMobileContainer = document.querySelector('.header-mobile-container');
    const menuBtn = document.querySelector('.menu-btn');

    if (headerMobileContainer) {
      headerMobileContainer.classList.add('active');
    }

    if (menuBtn) {
      menuBtn.classList.add('login_hide_menu');
    }
  }
const linkDeconnexion = document.querySelector('.header-mobile-container .title-deconnexion-container a:nth-child(2)');
const deconnexionLoader = document.querySelector('.deconnexion-loader');
if(linkDeconnexion){
linkDeconnexion.addEventListener('click', (e) => {
  e.preventDefault();
  deconnexionLoader.classList.add('active');
  closeHeaderMobileToggleAccount();

   $.ajax({
    url: '/account/logout',
    async: true,
    success: () => {
      if(window.location.pathname === "/account"){
        window.location.href = "/account/login";
      }
      else{
        console.log('1235')
       
       setTimeout(function() {
        
                var headerContainer = document.querySelector('.header-mobile-container');
                if (headerContainer) {
                    // Clear the cart count
                    var cartCount = headerContainer.querySelector('.header-cart-count .header-mobile-count');
                    if (cartCount) {
                        cartCount.textContent = '';
                    }

                    // Hide the arrow inside header-mobile-container
                    var arrowElement = headerContainer.querySelector('.arrow');
                    if (arrowElement) {
                        arrowElement.style.display = 'none';
                    }

                    // Add 'cart-is-empty' class to header link cart
                    var cartLink = headerContainer.querySelector('.header-link-cart');
                    if (cartLink) {
                        cartLink.classList.add('cart-is-empty');
                    }
                }
         if(document.querySelector('.customer-email.main_email')){
            const customerEmail = document.querySelector('.customer-email.main_email').value; // Replace with actual email on login
            saveCartWithEmail(customerEmail); 
          }
             
          }, 500); // Delay to ensure logout completes first (adjust as needed)
        deconnexionLoader.classList.remove('active');

        headerMobileContainer.classList.remove('connected');
        resetForm();
  
        navbarBlock.classList.remove('connected')
        // navbarBlock.addEventListener('click', popLogin);
  
        if(window.location.pathname === "/pages/shopify-quote"){

          $.ajax({
            type:"GET",
            url: "/pages/shopify-quote",
            dataType:"html",
            success: function(html){
              var newHtml = $(html).filter('main').html();  
              $('main').html(newHtml);
              CF.initializeForms('mMtjbR');
              localStorage.setItem('divtoscroll','#firststepactive');
              window.location.href = '/pages/shopify-quote';
            }
          })
        }

        if(window.location.pathname === "/pages/devis-shopify/" || window.location.pathname === "/pages/devis-shopify"){

          $.ajax({
            type:"GET",
            url: "/pages/devis-shopify/",
            dataType:"html",
            success: function(html){
              var newHtml = $(html).filter('main').html();  
              $('main').html(newHtml);
              CF.initializeForms('54tmwl');
              localStorage.setItem('divtoscroll','#firststepactive');
              window.location.href = '/pages/devis-shopify/';
            }
          })
        }
        
        if(window.location.pathname === "/cart"){
          updatePageCart();
        }
        else{
          updateStickyCart();
        }

        function updatePageCart(){
          const allTaskText = document.querySelectorAll('.task-text');
          const cartCounts = document.querySelectorAll('.cart-count, .header-cart-count');

          const allEmptyCart = document.querySelectorAll('.empty-cart-container');
          const allFilledCart = document.querySelectorAll('.filled-cart-container');

          const deliveryTop = document.querySelector('.cart-delivery-date.dv');
          deliveryTop.classList.add('hidden');

          cartCounts.forEach(cartCount => {
            cartCount.innerText = '0';
          })

          allEmptyCart.forEach(emptyCart => {
            emptyCart.classList.remove('hidden');
          })
          allFilledCart.forEach(filledCart => {
            filledCart.classList.add('hidden');
          })

          allTaskText.forEach(taskText => {
            taskText.innerText = ` ${taskText.dataset.taskSingular}`;
          })

          animZero();

          function animZero(){
            gsap.to(".emoji-page", {
              duration: 3, 
              motionPath:{
                path: "#page-cart #path-cart-anim",
                align: "#page-cart #path-cart-anim",
                alignOrigin: [0.5, 0.5],
                start:0.25,
                end:-0.75
              }
            });
          }
        }

        // function updateStickyCart(){
          const cartCounts = document.querySelectorAll('.header-cart-count');

          const headerLinksCart = document.querySelectorAll('.header-link-cart');
          
          cartCounts.forEach(cartCount => {
            cartCount.innerText = "0";
          })

          headerLinksCart.forEach(linkCart => {
            linkCart.classList.add('cart-is-empty');
          });
        // }
  
        const eyeBtnsConnexionMobile = document.querySelectorAll('.eye-btn-connexion')[1];
  
        eyeBtnsConnexionMobile.style.display = "none";
  
        // toggleMenu();
      }
    }
  })
})

}

const eyeBtnsConnexion = document.querySelectorAll('.eye-btn-connexion');

for(btn of eyeBtnsConnexion){
  btn.addEventListener('click', function(){
    const container = this.closest('.input-wrapper');
    const input = container.querySelector('input');

    if(this.classList.contains('active')){
      input.setAttribute('type', 'password');
    } else{
      input.setAttribute('type', 'text');
    }

    this.classList.toggle('active');
  })
}

if (screen.width > 989) {
  window.addEventListener('resize', () => {
    // Check if elements exist before proceeding
    if (headerMobileContainer && stickyCartMobile && menuBtn) {
      if (headerMobileContainer.classList.contains('active')) {
        document.body.style.overflow = 'unset';
        menuBtn.click();

        headerMobileContainer.classList.remove('active');
        headerMobileContainer.classList.remove('not-active');
        stickyCartMobile.classList.remove('active');
        stickyCartMobile.classList.remove('not-active');
      }
    }
  });
}


// toggle header my account on mobile

const accountFullName = document.querySelector('.block-title-deconnexion');
if(accountFullName){
accountFullName.addEventListener('click', () => {
  if(ordersInfosWrapper.classList.contains('active')){
    closeHeaderMobileToggleAccount();
  }
  else{
    openHeaderMobileToggleAccount();
  }
})
}

function openHeaderMobileToggleAccount(){
  gsap.to(ordersInfosWrapper, { height:'auto', overflow:'visible', duration:0 });

    ordersInfosWrapper.classList.add('active');
    accountContainerMobile.classList.add('active-mobile');
}

function closeHeaderMobileToggleAccount(){
  gsap.to(ordersInfosWrapper, { height:0, overflow:'hidden', duration:0 });

  ordersInfosWrapper.classList.remove('active');
  accountContainerMobile.classList.remove('active-mobile');
}

// cart page and sticky cart

document.addEventListener('click', function(event) {
  var openBtn_cart = event.target.closest('.open-delete');
  var cancelBtn_cart = event.target.closest('.button-popin-delete.cancel');
  var confirmBtn_cart = event.target.closest('.button-popin-delete.confirm');

  if (openBtn_cart) {
    openDelete(openBtn_cart);
  }

  if (cancelBtn_cart) {
    const buttonOpenDeletePopin = cancelBtn_cart.closest('.delete-column').querySelector('.open-delete');
    closeDelete(buttonOpenDeletePopin);
  }

  if (confirmBtn_cart) {
    const buttonOpenDeletePopin = confirmBtn_cart.closest('.delete-column').querySelector('.open-delete');
    confirmDelete(buttonOpenDeletePopin);
  }
});

// cart page and sticky cart

const allEmptyCart = document.querySelectorAll('.empty-cart-container');
const allFilledCart = document.querySelectorAll('.filled-cart-container');

const openDeleteButtons = document.querySelectorAll('.open-delete');
const cancelDeleteButtons = document.querySelectorAll('.button-popin-delete.cancel');
const confirmDeleteButtons = document.querySelectorAll('.button-popin-delete.confirm');

if(openDeleteButtons){
openDeleteButtons.forEach(button => {
  // button.addEventListener('click', function(){
  //   openDelete(button)
  // });
})

cancelDeleteButtons.forEach(button => {
  // button.addEventListener('click', function(){
  //   const buttonOpenDeletePopin = button.closest('.delete-column').querySelector('.open-delete');
  //   closeDelete(buttonOpenDeletePopin);
  // });
})

confirmDeleteButtons.forEach(button => {
  // button.addEventListener('click', function(){
  //   const buttonOpenDeletePopin = button.closest('.delete-column').querySelector('.open-delete');
  //   confirmDelete(buttonOpenDeletePopin);
  // });
})
}
function openDelete(currentButton){
  const currentCartItemContainer = currentButton.closest('.cart-item-container');
  const deleteContainer = currentButton.closest('.delete-column');
  const currentPopinDelete = deleteContainer.querySelector('.cart-popin-delete');

  document.querySelectorAll('.cart-popin-delete').forEach(popinDelete => {
    if(popinDelete !== currentPopinDelete){
      const deleteContainerOfPopinDelete = popinDelete.closest('.delete-column');
      const cartItemContainerOfPopinDelete = popinDelete.closest('.cart-item-container');
      const buttonOfPopinDelete = deleteContainerOfPopinDelete.querySelector('.open-delete');

      
      cartItemContainerOfPopinDelete.classList.remove('active-delete');
      popinDelete.classList.remove('active');
      buttonOfPopinDelete.classList.remove('active');
    }
  })

  if(currentPopinDelete.classList.contains('active')){
    currentPopinDelete.classList.remove('active');
    currentCartItemContainer.classList.remove('active-delete');
    currentButton.classList.remove('active');
  } else{
    currentPopinDelete.classList.add('active');
    currentCartItemContainer.classList.add('active-delete');
    currentButton.classList.add('active');
  }

}

function closeDelete(currentButton){
  const currentCartItemContainer = currentButton.closest('.cart-item-container');
  const deleteContainer = currentButton.closest('.delete-column');
  const currentPopinDelete = deleteContainer.querySelector('.cart-popin-delete');

  currentCartItemContainer.classList.remove('active-delete');
  currentPopinDelete.classList.remove('active');
  currentButton.classList.remove('active');
}

function confirmDelete(currentButton){
  const currentCartItemContainer = currentButton.closest('.cart-item-container');
  const deleteContainer = currentButton.closest('.delete-column');
  const currentPopinDelete = deleteContainer.querySelector('.cart-popin-delete');

  currentCartItemContainer.classList.remove('active-delete');
  currentPopinDelete.classList.remove('active');
  currentButton.classList.remove('active');

  ajaxCartDelete(currentCartItemContainer , currentButton.dataset.key);
}


function ajaxCartDelete(itemToDelete, key){

  // front code (to optimize performance)
  const activeCartContent = itemToDelete.closest('.cart-main-content');
  const sectionCartBottom = activeCartContent.querySelector('.section-cart-bottom');
  const blockEmptyCart = activeCartContent.querySelector('.empty-cart-container');
  const itemCountFront = activeCartContent.querySelectorAll('.cart-item-container').length;

  const headerLinksCart = document.querySelectorAll('.header-link-cart');
  
  const allItemsToDelete = document.querySelectorAll(`.cart-item-container[data-key="${key}"]`);

  updateCartNumbers(itemCountFront - 1);
  itemToDelete.classList.add('deleted');

  allItemsToDelete.forEach(item => {
    setTimeout(() => {
      item.remove();
    }, 2000);

    if(itemCountFront === 1){
      sectionCartBottom.classList.add('fade-cart');
      blockEmptyCart.classList.add('fade-cart');

      setTimeout(() => {
        headerLinksCart.forEach(linkCart => {
          linkCart.classList.add('cart-is-empty');
          linkCart.classList.remove('active');
        });
      }, 2000);

      setTimeout(() => {
        animZero();
      }, 2200);
    }
  })
  // end temporary front code 

  $.ajax({
  type: "POST",
  url: "/cart/change.js",
  dataType: "json",
  data: {
    id: key,
    quantity: 0,
    },
  })
  .then(() => {
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      updateTotalPrice(data.total_price);
      updateSubTotal(data.items_subtotal_price);
      updateDeliveryDate(activeCartContent);
    })
  })
  
  function updateTotalPrice(totalPrice) {
    const allTotalPriceTTC = document.querySelectorAll('.total-price-container .price-ttc');
    const allTVA = document.querySelectorAll('.tva-total-price');
  
    allTVA.forEach(tva => {
      let tvaAmount = parseFloat(totalPrice / 100 / 1.2 * 0.2).toFixed(2);
      tva.innerHTML = `${tvaAmount} ${tva.dataset.currency}`;
    });
  
    let totalPriceFormatted = (totalPrice / 100).toFixed(2).replace('.', ',');
  
    allTotalPriceTTC.forEach(price => {
      price.innerText = `${totalPriceFormatted} ${price.dataset.currency}`;
    });
  }
  
function updateSubTotal(subTotal) {
  const subTotalPrices = document.querySelectorAll('.top-subtotal .price-ttc');
  const subTotalVATs = document.querySelectorAll('.subtotal-tva-total-price');

  if (subTotalPrices.length > 0 && subTotalVATs.length > 0) {
    let subTotalFormatted = (subTotal / 100).toFixed(2).replace('.', ',');
    let vatAmount = parseFloat(subTotal / 100 / 1.2 * 0.2).toFixed(2);

    subTotalPrices.forEach(subTotalPrice => {
      subTotalPrice.innerText = `${subTotalFormatted} €`;
    });

    subTotalVATs.forEach(subTotalVAT => {
      subTotalVAT.innerText = `${vatAmount} €`;
    });
  }
} 




  function updateDeliveryDate(activeCartContent){
    const allCartDeliveryDate = document.querySelectorAll('.cart-delivery-date .delivery-date-value');

    const allCartItems = activeCartContent.querySelectorAll('.cart-item-container');

    let totalDaysToAdd = 0;

    allCartItems.forEach(item => {
      if(!item.classList.contains('deleted')){
        const days = parseInt(item.dataset.days);

        totalDaysToAdd += days;
      }
    })

    const filteredDate = new Date();

    for(let i = 0; i < totalDaysToAdd; i++){
      filteredDate.setDate(filteredDate.getDate() + 1);

      if(filteredDate.getDay() === 6){
        filteredDate.setDate(filteredDate.getDate() + 2);
      }
      else if(filteredDate.getDay() === 0){
        filteredDate.setDate(filteredDate.getDate() + 1);
      }
    }

    const year = filteredDate.getFullYear();
    const month = (filteredDate.getMonth() + 1).toString().padStart(2, '0'); // +1 car les mois commencent à 0
    const day = filteredDate.getDate().toString().padStart(2, '0');

    const finalDateFormat = `${day}/${month}/${year}`;

    allCartDeliveryDate.forEach(date => {
      date.innerText = finalDateFormat;
    })
  }

  const animZeroPathCartPage = document.querySelector('#page-cart #path-cart-anim');
  const animZeroPathStickyCartDesktop = document.querySelector('#sticky-desktop #path-cart-anim');
  const animZeroPathStickyCartMobile = document.querySelector('#sticky-mobile #path-cart-anim');

  function animZero(){
    if(window.location.pathname.includes('/cart')){
      gsap.to(".emoji-page", {
        duration: 3, 
        motionPath:{
          path: animZeroPathCartPage,
          align: animZeroPathCartPage,
          alignOrigin: [0.5, 0.5],
          start:0.25,
          end:-0.75
        }
      });
    }
    else{
      gsap.to(".emoji-sticky-desktop", {
        duration: 3, 
        motionPath:{
          path:animZeroPathStickyCartDesktop,
          align:animZeroPathStickyCartDesktop,
          alignOrigin: [0.5, 0.5],
          start:0.25,
          end:-0.75
        }
      });

      gsap.to(".emoji-sticky-mobile", {
        duration: 3, 
        motionPath:{
          path:animZeroPathStickyCartMobile,
          align:animZeroPathStickyCartMobile,
          alignOrigin: [0.5, 0.5],
          start:0.25,
          end:-0.75
        }
      });
    }
  }

  function updateCartNumbers(count){
    const allCartTaskText = document.querySelectorAll('.sticky-cart-task-text, .task-text')
    const deliveryTop = document.querySelector('.cart-delivery-date.dv');
    const cartWrapper = document.querySelector('.sticky .cart-items-wrapper');

    if(count === 0){
      setTimeout(() => {
        allEmptyCart.forEach(emptyCart => {
          emptyCart.classList.remove('hidden');
        })
        allFilledCart.forEach(filledCart => {
          filledCart.classList.add('hidden');
        })
  
        if(deliveryTop) deliveryTop.classList.add('hidden');
      }, 2000);
      
      allCartTaskText.forEach(taskText => {
        taskText.innerText = " " + taskText.dataset.taskSingular;
      })

      if(cartWrapper) cartWrapper.classList.remove('release-scroll'); // Null check added
    }
    else{
      allEmptyCart.forEach(emptyCart => {
        emptyCart.classList.add('hidden');
      })
      allFilledCart.forEach(filledCart => {
        filledCart.classList.remove('hidden');
      })

      allCartTaskText.forEach(taskText => {
        if(count === 1){
          taskText.innerText = " " + taskText.dataset.taskSingular;
          if(cartWrapper) cartWrapper.classList.add('release-scroll'); // Null check added
        }
        else{
          taskText.innerText = " " + taskText.dataset.taskPlural;
          if(cartWrapper) cartWrapper.classList.remove('release-scroll'); // Null check added
        }
      });
    }

    const allNumbers = document.querySelectorAll('.cart-count, .header-link-cart > span, .sticky-cart-count');

    allNumbers.forEach(number => {
      number.innerText = count;
    })
}

}

  // cart reassurance carousel

  const cartReassuranceContainers = document.querySelectorAll('.cart-reassurance-container');
if(cartReassuranceContainers){
  cartReassuranceContainers.forEach(cartContainer => {
    launchCarouselReassurance(cartContainer)
  })
}

  function launchCarouselReassurance(container){
    const allSlidesCartReassurance = container.querySelectorAll('.cart-item-reassurance');
    const allDotsCartReassurance = container.querySelectorAll('.section-cart-bottom .slider-dot');

    const delayCartReassuranceSlider = parseInt(container.dataset.delay) * 1000;
    let indexCartReassuranceSlider = 1;
    const indexMaxCartReassuranceSlider = allDotsCartReassurance.length;

    let reassuranceCartSliderInterval = setInterval(updateAutoCarouselCartReassurance, delayCartReassuranceSlider);
    
    allDotsCartReassurance.forEach(dot => {
      dot.addEventListener('click', () => {
        if(dot.dataset.index === indexCartReassuranceSlider){
          return;
        }
        else{
          updateCarouselCartReassurance(parseInt(dot.dataset.index));

          clearInterval(reassuranceCartSliderInterval);

          reassuranceCartSliderInterval = setInterval(updateAutoCarouselCartReassurance, delayCartReassuranceSlider);
        }
      })
    })
    
    function updateAutoCarouselCartReassurance(){
      const nextIndex = indexCartReassuranceSlider + 1;
    
      if(nextIndex > indexMaxCartReassuranceSlider){
        updateCarouselCartReassurance(1);
      }
      else{
        updateCarouselCartReassurance(nextIndex);
      }
    }
    
    function updateCarouselCartReassurance(index){
    
      indexCartReassuranceSlider = index;
    
      allDotsCartReassurance.forEach(dot => {
        if(parseInt(dot.dataset.index) === index){
          dot.classList.add('active');
        } else{
          dot.classList.remove('active');
        }
      })
    
      allSlidesCartReassurance.forEach(slide => {
        if(parseInt(slide.dataset.index) === index){
          slide.classList.add('active');
        } else{
          slide.classList.remove('active');
        }
      })
    }
  }

  // header display

  let oldScrollY = window.scrollY;
  let headerBlockHidingPermission = false;
  const headerBlock = document.querySelector('.header-wrapper');
  const stickyLogin = document.querySelector('.account-container');
  const stickyLoginCart = document.querySelector('.sticky-cart.header-desktop-sticky-cart'); // Corrected the query selector syntax
  if (headerBlock) {
    const headerStickyCart = headerBlock.querySelector('.header-mobile-sticky-cart');
    window.addEventListener('scroll', () => {
      var headerBlockStore = document.querySelector('.header__inline-menu a.blog_link');
      var headerCart = document.querySelector('.header-link-cart');
      var hamburgerNav = document.querySelector('.header-mobile-container');
      
      if (stickyLogin.classList.contains('active')) {
        // If .account-container has the active class
        headerBlock.classList.remove('hidden');
        headerBlock.classList.add('sticky-login-open');
        // Remove sticky-login-open class on scroll up
        if (oldScrollY > window.scrollY) {
          headerBlock.classList.remove('sticky-login-open');
        }
      } else if (stickyLoginCart.classList.contains('active')) {
        // If .sticky-cart has the active class
        headerBlock.classList.remove('hidden');
        headerBlock.classList.add('sticky-cart-open');
        // Remove sticky-cart-open class on scroll up
        if (oldScrollY > window.scrollY) {
          headerBlock.classList.remove('sticky-cart-open');
        }
      } else {
        // Normal scrolling behavior
        if (oldScrollY < window.scrollY) {
          if (headerBlockHidingPermission && !hamburgerNav.classList.contains('active')) {
            headerBlock.classList.add('hidden');
          }
        } else {
          headerBlock.classList.remove('hidden');
          setTimeout(function () {
            if (
              !hamburgerNav.classList.contains('active') &&
              !headerBlockStore.classList.contains('active') &&
              !headerCart.classList.contains('active')
            ) {
              if (window.scrollY > 5) {
                headerBlock.classList.add('hidden');
              }
            } else {
              var cleanMyInterval = setInterval(function () {
                if (
                  !hamburgerNav.classList.contains('active') &&
                  !headerBlockStore.classList.contains('active') &&
                  !headerCart.classList.contains('active')
                ) {
                  clearInterval(cleanMyInterval);
                  if (window.scrollY > 5) {
                    headerBlock.classList.add('hidden');
                  }
                }
              }, headerDelay);
            }
          }, headerDelay);
          headerStickyCart.classList.remove('not-active');
          hamburgerNav.classList.remove('not-active');
          headerBlock.classList.remove('sticky-cart-open');
          headerBlock.classList.remove('sticky-login-open');
        }
      }
      oldScrollY = window.scrollY;
    });
  }
  ScrollTrigger.create({
    trigger:'#MainContent',
    start:`top+=100 top`,
    end:`top+=100 top`,
    onEnter:() => {
      headerBlockHidingPermission = true;
    },
    onEnterBack:() => {
      headerBlockHidingPermission = false;
    }
  })

  // scroll top btn

  const scrollTop = document.querySelector('.scroll-top-container');
  // JORS-3704: the element is not emitted on the Cart Editor landing
  if (scrollTop) {

  ScrollTrigger.create({
    trigger:'#MainContent',
    start:`top+=300 top`,
    end:`top+=300 top`,
    onEnter:() => {
      scrollTop.classList.add('active');
    },
    onEnterBack:() => {
      scrollTop.classList.remove('active');
    }
  })

  ScrollTrigger.create({
    trigger:'.footer-bottom-wrapper',
    start:'top bottom',
    end:'top bottom',
    onEnter:() => {
      scrollTop.classList.add('footer-scroll');
    },
    onEnterBack:() => {
      scrollTop.classList.remove('footer-scroll');
    }
  })

  scrollTop.addEventListener('click', () => {
    gsap.to(window, {
      duration:0.8,
      ease:"power2.in",
      scrollTo:{
        y:'#MainContent'
      }
    })
  })
  }

// general click

function getParents(elem) {

  var parents = [];

  for ( ; elem && elem !== document; elem = elem.parentNode ) {
    parents.push(elem);
  }

  return parents;

};

document.addEventListener('click', (e) => {

  const allParents = getParents(e.target);

  if (!allParents.includes(headerBlockBlog) && !allParents.includes(headerLinkBlogDesktop)) {
    if (headerBlockBlog) {
        headerBlockBlog.classList.remove('active');
    }
    if (headerLinkBlogDesktop) {
        headerLinkBlogDesktop.classList.remove('active');
    }
  }


  // popin cart delete item

  for(parent of allParents){
    const allPopinDelete = document.querySelectorAll('.cart-popin-delete');

    if(!parent.classList.contains('cart-popin-delete') && !parent.classList.contains('open-delete') && !e.target.classList.contains('content-delete-text') && !e.target.classList.contains('content-delete') && !e.target.classList.contains('open-delete') && !e.target.classList.contains('cart-popin-delete') && !e.target.classList.contains('path-open-delete') && !e.target.classList.contains('svg-open-delete')){

      allPopinDelete.forEach(popinDelete => {
        if(popinDelete.classList.contains('active')){
          const deleteContainerOfPopinDelete = popinDelete.closest('.delete-column');
          const buttonOfPopinDelete = deleteContainerOfPopinDelete.querySelector('.open-delete');
          const cartItemContainerOfPopinDelete = popinDelete.closest('.cart-item-container');

          cartItemContainerOfPopinDelete.classList.remove('active-delete');
          popinDelete.classList.remove('active');
          buttonOfPopinDelete.classList.remove('active');
        }
      })
    } else{
      break;
    }
      
  }
})

document.addEventListener('mousedown', (e) => {

  const allParents = getParents(e.target);

  // popup login

  if (accountContainer && navbarBlock) {
    if (!allParents.includes(navbarBlock) && !allParents.includes(globalLinkLogin)) {
      accountContainer.classList.remove('active');
      navbarBlock.classList.remove('active');
      document.querySelector('.header-wrapper').classList.remove('sticky-login-open');
    }
  }


  // sticky cart

  if (stickyCartDesktop && headerCartLinkDesktop) {
    if (!allParents.includes(stickyCartDesktop) && !allParents.includes(headerCartLinkDesktop)) {
        stickyCartDesktop.classList.remove('active');
        headerCartLinkDesktop.classList.remove('active');
    }
  }


})

// hero section

const allImgHeroHome = document.querySelectorAll('.hero-carousel img.slider-image');
const allImgHeroHomeLength = allImgHeroHome.length;

let indexHomeHeroCarousel = 1;

if(allImgHeroHomeLength > 1){
  setInterval(iteration, 7000)
}

function iteration(){
  allImgHeroHome[indexHomeHeroCarousel - 1].classList.add('hide');

  setTimeout(() => {
    allImgHeroHome[indexHomeHeroCarousel - 1].classList.remove('hide');
  }, 1000);

  if(indexHomeHeroCarousel !== allImgHeroHomeLength){
    indexHomeHeroCarousel++;
  }
  else{
    indexHomeHeroCarousel = 1;
  }

  allImgHeroHome.forEach(img => {
    img.style.opacity = 0;

    allImgHeroHome[indexHomeHeroCarousel - 1].style.opacity = 1;
  })
}

function countWords(str) {
  return str.trim().split(/\s+/).length;
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if(!$('body').hasClass('landing')){
  let localstoreLanguage = $.cookie("store_language")
  // alert($.cookie("store_language"))
  // alert(localstoreLanguage);
  document.addEventListener('DOMContentLoaded', function() {
  if(!$('body').hasClass('popin')){
    function getBrowserLanguage() {
      // JORS-4384: real browser language captured before the Termly override
      var userLang = window.joraBrowserLanguage || navigator.language || navigator.userLanguage; 
      return userLang;
    }
      
    function getStoreLanguage() {
      var storeLanguageMeta = Shopify.locale;
      return storeLanguageMeta;
    }
    
    function showLanguagePopup() {
      var popupContainer = document.querySelector('.language_popup');
      var body = document.querySelector('body');
      if (popupContainer) {
        popupContainer.style.display = 'block';
        body.classList.add('language_popup_active')
      }
    }
    
    function hideLanguagePopup() {
      var popupContainer = document.querySelector('.language_popup');
      var body = document.querySelector('body');
      if (popupContainer) {
        popupContainer.style.visibility = 'hidden';
        popupContainer.style.opacity = 0;
        setTimeout(function(){
          body.classList.remove('language_popup_active');
        },500)
      }
    }
    
    function checkLanguageAndTogglePopup() {
      var browserLanguage = getBrowserLanguage().split('-')[0]; 
      var storeLanguage = getStoreLanguage();
      if (browserLanguage && storeLanguage && browserLanguage.toLowerCase() === storeLanguage.toLowerCase()) {
        hideLanguagePopup();
      } else {
        if(browserLanguage == 'fr') {
          $('.language_selection_btn, .continue_btn').hide();
          $('.language_selection_btn[data-href="en"], .continue_btn[data-href="fr"]').show();
        }else if(browserLanguage == 'en') {
          $('.language_selection_btn, .continue_btn').hide();
          $('.language_selection_btn[data-href="fr"], .continue_btn[data-href="en"]').show();
        }
        showLanguagePopup();
      }
    }
    
    if(localstoreLanguage === '' || localstoreLanguage == null || localstoreLanguage == undefined){
      checkLanguageAndTogglePopup();
    }else {
      hideLanguagePopup();
      var pathName = window.location.pathname;
      var href = window.location.href; 
      var hasValue = window.location.hash;
      console.log(hasValue);
      var myDate = new Date();
      myDate.setMonth(myDate.getMonth() + 12);
      // alert(myDate)
      // JORS-3816: decide on the host and a leading /fr segment only, not on "fr" anywhere
      // in the URL (a query such as jl_lp=%2Ffr%2F... matched it), and keep the query string.
      var isFrHost = window.location.hostname.indexOf('fr.') === 0;
      var hasFrPrefix = /^\/fr(\/|$)/.test(pathName);
      var search = window.location.search;
      if(localstoreLanguage === 'fr' && (!isFrHost || hasFrPrefix)) {
        pathName = pathName.replace(/^\/fr(\/|$)/,'/')
        window.location.replace('https://fr.joraleka.com'+pathName+search+hasValue);
        return false;
      } else if (localstoreLanguage === 'en' && (isFrHost || hasFrPrefix)) {
        pathName = pathName.replace(/^\/fr(\/|$)/,'/')
        window.location.replace('https://joraleka.com'+pathName+search+hasValue);
        return false;
      }
    }
  
    var languageButtons = document.querySelectorAll('.continue_btn');
    languageButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        var selectedLanguage = this.getAttribute('data-href');
        var myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);
        $.cookie("store_language", selectedLanguage, {expires: myDate,path: "/", domain: "joraleka.com"});
        // document.cookie ="store_language=" + selectedLanguage + ";expires=" + myDate + ";domain=joraleka.com;path=/;samesite:lax";
        window.location.href = 'https://' + selectedLanguage + '.joraleka.com' + window.location.pathname;
      });
    }); 
  
    $('.language_selection a:not(.continue_btn)').on('click',function(){
      var selectedLanguage = $(this).data('href');
      var myDate = new Date();
      myDate.setMonth(myDate.getMonth() + 12);
      $.cookie("store_language", selectedLanguage, {expires: myDate,path: "/", domain: "joraleka.com"});
      // document.cookie ="store_language=" + selectedLanguage + ";expires=" + myDate + ";domain=joraleka.com;path=/;samesite:lax";
      hideLanguagePopup();
    })
  }
  
});
}

window.addEventListener('DOMContentLoaded', () => {
  var navList = document.querySelectorAll('.header-last-article');
  navList.forEach( (el) => {
    var string = el.querySelector('h4').innerHTML;
    var outerHeight = el.querySelector('h4').offsetHeight;
    if(outerHeight > 21){
      var newString = string.split(" ", 10);
      var jointString = newString.join(' ');
      el.querySelector('h4').innerHTML = jointString+'...'; 
      var outerHeight = el.querySelector('h4').offsetHeight;
      if(outerHeight > 21){
        var newJoinString = jointString.split(' ', 6);
        el.querySelector('h4').innerHTML = newJoinString.join(' ')+'...'; 
      }
      
    }
  } )
  // var recentArticle = document.querySelectorAll('.recent-article');
  // recentArticle.forEach((el) => {
  //   var titleDesc = el.querySelector('.title-desc');
  //   var string = titleDesc.querySelector('p').innerHTML;
  //   var countWord = countWords(string);
  //   if(countWord > 15){
  //     var stringArray = string.split(' ', 15);
  //     titleDesc.querySelector('p').innerHTML = stringArray.join(' ');
      
  //   }
  // })
})

// class LocalizationForm extends HTMLElement {
//   constructor() {
//     super();
//     this.elements = {
//       input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
//       button: this.querySelector('button'),
//       panel: this.querySelector('ul'),
//     };
//     this.elements.button.addEventListener('click', this.openSelector.bind(this));
//     this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
//     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

//     this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
//   }

//   hidePanel() {
//     this.elements.button.setAttribute('aria-expanded', 'false');
//     this.elements.panel.setAttribute('hidden', true);
//   }

//   onContainerKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;

//     this.hidePanel();
//     this.elements.button.focus();
//   }

//   onItemClick(event) {
//     event.preventDefault();
//     const form = this.querySelector('form');
//     this.elements.input.value = event.currentTarget.dataset.value;
//     if (form) form.submit();
//   }

//   openSelector() {
//     this.elements.button.focus();
//     this.elements.panel.toggleAttribute('hidden');
//     this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
//   }

//   closeSelector(event) {
//     const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
//     if (event.relatedTarget === null || shouldClose) {
//       this.hidePanel();
//     }
//   }
// }

// customElements.define('localization-form', LocalizationForm);

$('.navigation .navigation-inner .page_number').on('click',function(e){
  var id = $(this).data('index');
  var next_avilable = parseInt(id)+3;
  var prev_avilable = parseInt(id)-3;
  var next_div = $('.expert-recent-posts-slider.recent-article-mobile-hide .slick__slide[data-page="'+next_avilable+'"]').length;
  var prev_div =  $('.expert-recent-posts-slider.recent-article-mobile-hide .slick__slide[data-page="'+prev_avilable+'"]').length;
  console.log('next_avial '+next_div);
  if(next_div > 0 && prev_div > 0){
    $('.page_next').parents('.navigation-inner').addClass('active');
    $('.page_prev').parents('.navigation-inner').addClass('active');
  }else if(next_div > 0){
    $('.pager_nav').removeClass('active');
    $('.page_next').parents('.navigation-inner').addClass('active');
  }else{
    $('.pager_nav').removeClass('active');
    $('.page_prev').parents('.navigation-inner').addClass('active');
  }
  $('.navigation .navigation-inner').removeClass('current');
  $(this).parents('.navigation-inner').addClass('current');
  $('.expert-recent-posts-slider.recent-article-mobile-hide .slick__slide').hide()
  $('.expert-recent-posts-slider.recent-article-mobile-hide .slick__slide[data-page="'+id+'"]').show();
})
$('.page_next').on('click',function(e){
  $(this).parents('.navigation-inner').removeClass('active');
  var id_nex = $('.navigation-inner.current').find('.page_number').data('index');
  var new_index = parseInt(id_nex)+3;
  var length_nx = $('.navigation .navigation-inner .page_number[data-index="'+new_index+'"]').length;
  if(length_nx > 0){
    $('.navigation .navigation-inner .page_number[data-index="'+new_index+'"]').click();
  }
})
$('.page_prev').on('click',function(e){
  $(this).parents('.navigation-inner').removeClass('active');
  var id_nex = $('.navigation-inner.current').find('.page_number').data('index');
  var new_index = parseInt(id_nex)-3;
  var length_nx = $('.navigation .navigation-inner .page_number[data-index="'+new_index+'"]').length;
  if(length_nx > 0){
    $('.navigation .navigation-inner .page_number[data-index="'+new_index+'"]').click();
  }
})

if($('.expert-recent-posts-slider').length > 0) {
  $('.expert-recent-posts-slider.recent-article-desktop-hide').slick({
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    prevArrow:'<svg class="prev prev-arrow-btn" xmlns="http://www.w3.org/2000/svg" width="22.643" height="15.195" viewBox="0 0 22.643 15.195"><path id="XMLID_29_" d="M2.162,8.493l4.17-4.17V21.377a1.266,1.266,0,0,0,2.533,0V4.323l4.17,4.17A1.266,1.266,0,1,0,14.825,6.7L8.493.371A1.266,1.266,0,0,0,6.7.371L.371,6.7A1.266,1.266,0,0,0,2.162,8.493Z" transform="translate(22.643) rotate(90)" fill="#65d09a"/></svg>',
    nextArrow:'<svg class="next next-arrow-btn" xmlns="http://www.w3.org/2000/svg" width="22.644" height="15.196" viewBox="0 0 22.644 15.196"><path id="XMLID_29_" d="M2.162,14.151l4.17,4.17V1.266a1.266,1.266,0,0,1,2.533,0V18.32l4.17-4.17a1.266,1.266,0,1,1,1.791,1.791L8.493,22.273a1.266,1.266,0,0,1-1.791,0L.371,15.941a1.266,1.266,0,1,1,1.791-1.791Z" transform="translate(22.644) rotate(90)" fill="#65d09a"/></svg>',
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true
        }
      }
    ]
  });
  
  $(window).on('load',function(){
   if($(this).width() < 850){
     var height = $('.expert-recent-posts-slider.recent-article-desktop-hide').height();
     $('.expert-recent-posts-slider.recent-article-desktop-hide').css('min-height', height);
   }
 }) 

 $(window).resize(function(){
   if($(this).width() < 850){
     setTimeout(function(){
       var height = $('.expert-recent-posts-slider.recent-article-desktop-hide').height();
       $('.expert-recent-posts-slider.recent-article-desktop-hide').css('min-height', height);
     }, 500)
   }
 }) 

  var reviFromLast = false;
  var reverseProcess = false;
  var dotsToShow = $('#dots_to_show').val();
  $('.expert-recent-posts-slider.recent-article-desktop-hide .slick-dots li:not(:lt('+dotsToShow+'))').hide();
  dotsToShow = parseInt(dotsToShow);
  $(document).on('click','.next-arrow-btn',function(){
    var currentIndex = $('.slick__slide.slick-active').data('slick-index');
    // currentIndex = currentIndex + 1
    // $('.expert-recent-posts-slider.recent-article-desktop-hide').slick('slickGoTo', currentIndex);
    if(currentIndex%dotsToShow == 0){
      setTimeout(function(){
       var indexSum = 0;
        $('.slick-dots').find('li').each(function(index, el){
         if($(this).hasClass('slick-active')){
           var elindex = index;
           indexSum = elindex + dotsToShow;
             $(this).show();
         }else if(indexSum > index){
            $(this).show();
         }else{
           $(this).hide();
         }
        });
      },500)
    }
  })

  
  $('.expert-recent-posts-slider.recent-article-desktop-hide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var slideCount = slick.slideCount;
    if(slideCount - 1 == nextSlide){
      $('.next-arrow').addClass('grey');
    }else{
      $('.next-arrow').removeClass('grey');
    }

    if(nextSlide == 0){
      $('.prev-arrow').addClass('grey');
    }else{
      $('.prev-arrow').removeClass('grey');
    }
    
  });

  $(document).on('click','.prev-arrow-btn',function(){
    var currentIndex = $('.slick__slide.slick-active').data('slick-index');
    // if(reviFromLast == false && reverseProcess == false){
    //   currentIndex = currentIndex - 1; 
    // }
    //$('.expert-recent-posts-slider.recent-article-desktop-hide').slick('slickGoTo', currentIndex);
    reviFromLast = false;
    reverseProcess = false;
    var minV = dotsToShow - 1
    if(currentIndex%dotsToShow == minV){
      var activeIndex = $('.slick-dots li.slick-active').find('button').html();
      activeIndex = parseInt(activeIndex);
      
      var nactiveIndex = parseInt(activeIndex) - dotsToShow;
      $('.slick-dots').find('li').each(function(index, el){
        if($(this).hasClass('slick-active')){
         var elindex = index;
         var minusValue = dotsToShow - 1;
         indexSum = elindex - minusValue;
         // indexSum = elindex - 3;
         $(this).show();
        }else if(nactiveIndex <= index && activeIndex > index){
          $(this).show();
        }else{
         $(this).hide();
        }
      });
    }
  })

  $('.expert-recent-posts-slider.recent-article-desktop-hide').on('swipe', function(event, slick, direction){
    var sliderCount = slick.slideCount;
    if(direction == 'left'){
      var currentIndex = $('.slick__slide.slick-active').data('slick-index');
      if(currentIndex%dotsToShow == 0){
        var indexSum = 0;
        $('.slick-dots').find('li').each(function(index, el){
         if($(this).hasClass('slick-active')){
           var elindex = index;
           indexSum = elindex + dotsToShow;
             $(this).show();
         }else if(indexSum > index){
            $(this).show();
         }else{
           $(this).hide();
         }
        });
      }
    }else{
      var currentIndex = $('.slick__slide.slick-active').data('slick-index');
      var minV = dotsToShow - 1
      if(currentIndex%dotsToShow != 0 && sliderCount - 2 == currentIndex){
        setTimeout(function(){
          reviFromLast = true;
          $('.prev-arrow-btn').trigger('click');
        },500)
      }else if(currentIndex%dotsToShow == minV){
        setTimeout(function(){
          reviFromLast = false;
          reverseProcess = true;
          $('.prev-arrow-btn').trigger('click');
        },500)
      }
    }
  }); 
}

if($('.recent-posts-slider').length > 0) {
  $('.recent-posts-slider').slick({
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
          centerPadding: '50px'
        }
      }
    ]
  });
}


jQuery(document).ready(function(){
  var divtoscroll = localStorage.getItem('divtoscroll');
  if(divtoscroll != '' && divtoscroll != undefined){
    setTimeout(function(){
      jQuery('html,body').animate({
        scrollTop:jQuery(divtoscroll).offset().top
      },1000)
      localStorage.removeItem('divtoscroll')
    },1000)
  }
})




document.addEventListener('DOMContentLoaded', function() {
    // Select the logout button (Ensure you target the correct element)
    var logoutButton = document.querySelector('.navbar-block.connected, .logged_out_mobile');

    if (logoutButton) {
        logoutButton.addEventListener('click', function(event) {
            // Ensure logout event goes through (use event.preventDefault() if needed)
            setTimeout(function() {
              if(document.querySelector('.customer-email.main_email')){
                const customerEmail = document.querySelector('.customer-email.main_email').value; // Replace with actual email on login
                saveCartWithEmail(customerEmail); 
              }
                // Create a new XMLHttpRequest object to clear the cart after logout
                // var xhr = new XMLHttpRequest();
                // xhr.open('POST', '/cart/clear.js', true);
                // xhr.setRequestHeader('Content-Type', 'application/json');

                // // Set up a callback function to handle the response
                // xhr.onload = function() {
                //     if (xhr.status === 200) {
                //         console.log('Cart cleared after logout.');
                //         // Optionally update the cart UI here
                //     } else {
                //         console.error('Failed to clear the cart. Status:', xhr.status);
                //     }
                // };

                // // Handle errors
                // xhr.onerror = function() {
                //     console.error('Request to clear cart failed.');
                // };

                // // Send the request
                // xhr.send();
            }, 500); // Delay to ensure logout completes first (adjust as needed)
        });
    } else {
        console.log('Logout button not found.');
    }

});



 $(document).ready(function () {
        $(".title_cover").on("click", function () {
            650 >= $(window).width() && ($(this).toggleClass("active"), $(this).next(".inner_part").toggleClass("active"));
        }),
            $(window).on("resize", function () {
                $(window).width() > 650 && ($(".title_cover").removeClass("active"), $(".inner_part").removeClass("active"));
            });
    });
document.addEventListener("DOMContentLoaded", function () {
    // Extract customer_email from URL
    const urlParams = new URLSearchParams(window.location.search);
    const customerEmail = urlParams.get("customer_email") ? decodeURIComponent(urlParams.get("customer_email")).toLowerCase() : null;

    // Get the currently logged-in user's email from Shopify (Modify selector if needed)
    const loggedInEmailElement = document.querySelector(".customer-logged-in-email"); // Update selector if needed
    const loggedInEmail = loggedInEmailElement ? loggedInEmailElement.textContent.trim().toLowerCase() : null;

    // if (loggedInEmail && customerEmail) {
    //     if (loggedInEmail === customerEmail) {
    //         console.log("Emails match! Redirecting to checkout...");
    //         window.location.href = "/checkout";
    //     } else {
    //         console.log("Emails do not match! Staying on the account page.");
    //     }
    // } else {
    //     console.log("No valid customer email detected. Staying on the account page.");
    // }
});


    // // Extract customer_email from URL
    // const url = decodeURIComponent(window.location.href);
    // const match = url.match(/customer_email=([^&]*)/);
    // const customerEmail = match ? decodeURIComponent(match[1]).toLowerCase() : null;

    // // Get the currently logged-in user's email from Shopify (Example: adjust selector based on theme)
    // const loggedInEmailElement = document.querySelector(".customer-logged-in-email"); // Update with actual selector
    // const loggedInEmail = loggedInEmailElement ? loggedInEmailElement.textContent.trim().toLowerCase() : null;

    // if (loggedInEmail) {
    //     // If logged-in user exists and email does not match the customerEmail in URL, redirect to account page
    //     if (!customerEmail || loggedInEmail !== customerEmail) {
    //         console.log("Logged-in user does not match the requested email. Redirecting to account page...");
    //         window.location.href = "/account";
    //         return;
    //     } else {
    //         console.log("Emails match! Redirecting to checkout...");
    //         window.location.href = "/checkout";
    //     }
    // } else {
    //     console.log("No logged-in user detected. Redirecting to login/account page...");
    //     window.location.href = "/account";
    // }


document.addEventListener('DOMContentLoaded', () => {
  
    const promoInputStickyDesktop = document.getElementById('promo-code-desktop-sticky');
    const discountMessageStickyDesktop = document.getElementById('discount-message-desktop-sticky');
    const errorMessageStickyDesktop = document.getElementById('error-message-desktop-sticky');
    const totalPriceStickyDesktop = document.querySelector('.total-price-container .price-ttc');
    const vatAmountStickyDesktop = document.querySelector('.total-price-container .tva-total-price'); // New VAT Element
    const applyButtonStickyDesktop = document.querySelector('.apply-button');
    const promoCodeLabelStickyDesktop = document.querySelector('.promo-label-desktop');
    const promoCodeCoverStickyDesktop = document.querySelector('.promo-code-desktop');
    const currencySymbol = window.currencySymbol;
    let originalTotalStickyDesktop = parseFloat(totalPriceStickyDesktop.textContent.replace(window.currencySymbol, '').replace(',', '.'));

    let originalVatStickyDesktop = parseFloat(vatAmountStickyDesktop.textContent.replace(window.currencySymbol, '').replace(',', '.'));


    // // Get discount data from cookies
    // const discountCodeStickyDesktop = getCookieValueStickyDesktop('discount_code');
    // const discountAmountStickyDesktop = parseFloat(getCookieValueStickyDesktop('discount_amount'));
    // const discountTypeStickyDesktop = getCookieValueStickyDesktop('discount_type');

    // // If discount exists, restore it
    // if (discountCodeStickyDesktop && discountAmountStickyDesktop && discountTypeStickyDesktop) {
    //     promoInputStickyDesktop.value = discountCodeStickyDesktop; // Show code in input
    //     applyDiscountCodeStickyDesktop(discountCodeStickyDesktop, discountAmountStickyDesktop, discountTypeStickyDesktop, originalTotalStickyDesktop, originalVatStickyDesktop, false);
    // }

    // Enable/Disable apply button based on input
  
    promoInputStickyDesktop.addEventListener('input', () => {
        applyButtonStickyDesktop.disabled = promoInputStickyDesktop.value.trim() === '';
    });

    applyButtonStickyDesktop.addEventListener('click', () => {
        const code = promoInputStickyDesktop.value.trim();
        if (code) {
            applyDiscountCodeStickyDesktop(code, null, null, originalTotalStickyDesktop, true);
        }
    });

    promoInputStickyDesktop.oninput = () => {
      if (promoInputStickyDesktop.value.trim() === '') {
        errorMessageStickyDesktop.style.display = 'none';
        applyButtonStickyDesktop.classList.remove("error");
      }
    };

   function applyDiscountCodeStickyDesktop(code, savedDiscountAmount, savedDiscountType, originalTotalStickyDesktop, saveToCookies = true) {
    const url = `https://app.joraleka.com/discount.php?discount_code=${encodeURIComponent(code)}`;

    fetch(url)
        .then(response => response.json())
        .then(data => {
            errorMessageStickyDesktop.textContent = '';
            errorMessageStickyDesktop.style.display = 'none';

            if (data.value && data.value_type) {
                let discountAmount = savedDiscountAmount !== null ? savedDiscountAmount : parseFloat(data.value);
                let discountType = savedDiscountType || data.value_type;
                
                let total = originalTotalStickyDesktop;
                let vatAmount = originalVatStickyDesktop;
                let deduction = 0;
                let vatDeduction = 0;
                let deductionMessage = '';

                // --- LOGIC FIX START ---
                // If savedDiscountAmount is NOT null, it means the script is RESTORING the UI.
                // In this case, 'originalTotalStickyDesktop' (passed from the fetch chain) 
                // is already the discounted price from Shopify's server.
                // We show the deduction message but do NOT subtract from the total again.
                
                if (discountType === 'fixed_amount') {
                    deduction = Math.abs(discountAmount);
                    vatDeduction = (deduction * originalVatStickyDesktop) / originalTotalStickyDesktop;
                    
                    // Only subtract if this is a fresh application (user clicked apply)
                    if (savedDiscountAmount === null) {
                        total -= deduction;
                        vatAmount -= vatDeduction;
                    }
                    
                    deductionMessage = `${deduction.toFixed(2).replace('.', ',')} ${window.currencySymbol}`;
                    deductionMessage += ` <sup>inc. VAT</sup>`;

                } else if (discountType === 'percentage') {
                    // Calculate deduction based on the original (pre-discount) price 
                    // To get pre-discount price from a discounted price: discountedPrice / (1 - (percent/100))
                    let preDiscountTotal = (savedDiscountAmount !== null) ? (total / (1 - (Math.abs(discountAmount) / 100))) : total;
                    
                    deduction = preDiscountTotal * (Math.abs(discountAmount) / 100);
                    vatDeduction = (originalVatStickyDesktop * (Math.abs(discountAmount) / 100)); // Simplified VAT logic for percentages

                    // Only subtract if this is a fresh application
                    if (savedDiscountAmount === null) {
                        total -= deduction;
                        vatAmount -= vatDeduction;
                    }

                    deductionMessage = `${discountAmount.toFixed(0)}% soit ${deduction.toFixed(2).replace('.', ',')} ${window.currencySymbol}`;
                    deductionMessage += ` <sup>inc. VAT</sup>`;
                }
                // --- LOGIC FIX END ---

                // Format the final strings
                const finalTotalDisplay = Math.max(total, 0).toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;
                const finalVatDisplay = Math.max(vatAmount, 0).toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;

                // Update UI
                totalPriceStickyDesktop.textContent = finalTotalDisplay;
                vatAmountStickyDesktop.textContent = finalVatDisplay;
                
                discountMessageStickyDesktop.innerHTML = deductionMessage;
                discountMessageStickyDesktop.style.display = 'block';
                promoCodeLabelStickyDesktop.classList.add('active');
                promoCodeCoverStickyDesktop.style.display = 'flex';
                promoInputStickyDesktop.disabled = true;
                applyButtonStickyDesktop.disabled = true;
                applyButtonStickyDesktop.style.visibility = 'hidden';

                addClearButtonStickyDesktop();

                // Save to cookies if necessary
                if (saveToCookies) {
                    setCookieStickyDesktop('discount_code', code, 1);
                    setCookieStickyDesktop('discount_amount', discountAmount, 1);
                    setCookieStickyDesktop('discount_type', discountType, 1);
                }

                // Sync cart attributes with Shopify API
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        attributes: {
                            discount_code: code,
                            discount_amount: discountAmount,
                            discount_type: discountType
                        }
                    })
                });

            } else {
                handleDiscountErrorStickyDesktop(data);
            }
        })
        .catch(error => {
            console.error('Fetch error:', error);
            errorMessageStickyDesktop.textContent = 'Failed to apply discount code.';
            errorMessageStickyDesktop.style.display = 'block';
        });
}
  

// --- New --- Load discount from Shopify cart attributes if exists ---
// --- Updated Desktop Sync Logic ---
if (document.querySelector('.header-desktop-sticky-cart')) {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        // PRIORITY 1: Check Shopify Server Session (The "Truth")
        // If this is empty, the user removed it at checkout.
        if (!cart.cart_level_discount_applications || cart.cart_level_discount_applications.length === 0) {
            console.log("Sticky Desktop: No active discount on server. Cleaning local data.");
            removeDiscountStickyDesktop(); // Call your reset function
            return;
        }

        // PRIORITY 2: If session exists, try to restore from Attributes
        if (cart.attributes && cart.attributes.discount_code && cart.attributes.discount_amount && cart.attributes.discount_type) {
            const discountCode = cart.attributes.discount_code;
            const discountAmount = parseFloat(cart.attributes.discount_amount);
            const discountType = cart.attributes.discount_type;

            promoInputStickyDesktop.value = discountCode; 
            applyDiscountCodeStickyDesktop(discountCode, discountAmount, discountType, originalTotalStickyDesktop, false);
        
        // PRIORITY 3: If session exists but attributes are empty, restore from the Session Application
        } else {
            const discountApp = cart.cart_level_discount_applications[0];
            if (discountApp && discountApp.type === 'discount_code') {
                const discountCode = discountApp.title || '';
                const discountAmount = parseFloat(discountApp.value) || 0;
                const discountType = (discountAmount > 0 && discountAmount <= 100) ? 'percentage' : 'fixed_amount';

                promoInputStickyDesktop.value = discountCode;
                applyDiscountCodeStickyDesktop(discountCode, discountAmount, discountType, originalTotalStickyDesktop, false);
            }
        }
    })
    .catch(error => console.error("Sticky Desktop Fetch Error:", error));
}

 


    function handleDiscountErrorStickyDesktop(data) {
        const errorMessages = {
            error: errorMessageStickyDesktop.dataset.textError,
            limit_reach: errorMessageStickyDesktop.dataset.textLimitreach,
            expire: errorMessageStickyDesktop.dataset.textExpire,
            customer_error: errorMessageStickyDesktop.dataset.textCustomererror,
            product_error: errorMessageStickyDesktop.dataset.textProducterror,
            mini_order: errorMessageStickyDesktop.dataset.textMiniorder,
        };

        const errorMessage = errorMessages[data.error] || errorMessages.error || 'Invalid Discount Code';
        errorMessageStickyDesktop.textContent = errorMessage;
        applyButtonStickyDesktop.classList.add("error");
        errorMessageStickyDesktop.style.display = 'block';
        discountMessageStickyDesktop.style.display = 'none';
    }

    function addClearButtonStickyDesktop() {
        // Check if button already exists to avoid duplicates
        if (!document.querySelector('.clear-discount-sticky')) {
            const clearBtn = document.createElement('button');
            clearBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0602/6376/0064/files/cross-ic.svg?v=1741066569" alt="cross icon" width="15" height="15" style="cursor: pointer;">';
            clearBtn.className = 'clear-discount-sticky';
            clearBtn.style.marginLeft = '10px';
            clearBtn.addEventListener('click', removeDiscountStickyDesktop);
            promoInputStickyDesktop.parentNode.appendChild(clearBtn);
            promoInputStickyDesktop.parentNode.classList.add("applied");
        }
    }

   function removeDiscountStickyDesktop() {
    // 1. Get the actual pre-discount subtotal from the page
    const subtotalEl = document.querySelector('.top-subtotal .price-ttc');
    const vatSubtotalEl = document.querySelector('.subtotal-tva-total-price');

    const trueOriginalTotal = parseFloat(subtotalEl.textContent.replace(window.currencySymbol, '').replace(',', '.'));
    const trueOriginalVAT = parseFloat(vatSubtotalEl.textContent.replace(window.currencySymbol, '').replace(',', '.'));

    // 2. Reset UI to true original totals
    totalPriceStickyDesktop.textContent = trueOriginalTotal.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;
    vatAmountStickyDesktop.textContent = trueOriginalVAT.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;

    // 3. Reset messages and input fields
    discountMessageStickyDesktop.textContent = '';
    discountMessageStickyDesktop.style.display = 'none';
    errorMessageStickyDesktop.textContent = '';
    errorMessageStickyDesktop.style.display = 'none';
    promoInputStickyDesktop.value = '';
    promoInputStickyDesktop.disabled = false;
    promoInputStickyDesktop.parentNode.classList.remove("applied");

    const clearBtn = document.querySelector('.clear-discount-sticky');
    if (clearBtn) clearBtn.remove();

    applyButtonStickyDesktop.style.visibility = 'visible';
    applyButtonStickyDesktop.removeAttribute('disabled');

    // 4. Clear local cookies
    deleteCookieStickyDesktop('discount_code');
    deleteCookieStickyDesktop('discount_amount');
    deleteCookieStickyDesktop('discount_type');

    // 5. Tell Shopify to kill the session and attributes
    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            discount: "", // Clears the Shopify session coupon
            attributes: {
                discount_code: '',
                discount_amount: '',
                discount_type: ''
            }
        })
    })
    .then(response => response.json())
    .then(cart => {
        console.log("Discount removed and totals reset to subtotal");
        // Re-sync the background data
        if (typeof syncCartDataDiscount === 'function') {
            syncCartDataDiscount();
        }
    });
}

    // function removeDiscountStickyDesktop() {
    //     totalPriceStickyDesktop.textContent = originalTotalStickyDesktop.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;
    //     vatAmountStickyDesktop.textContent = originalVatStickyDesktop.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;

    //     discountMessageStickyDesktop.textContent = '';
    //     discountMessageStickyDesktop.style.display = 'none';
    //     errorMessageStickyDesktop.textContent = '';
    //     errorMessageStickyDesktop.style.display = 'none';
    //     promoInputStickyDesktop.value = '';
    //     promoInputStickyDesktop.disabled = false;
    //      promoInputStickyDesktop.parentNode.classList.remove("applied");

    //     const clearBtn = document.querySelector('.clear-discount-sticky');
    //     if (clearBtn) clearBtn.remove();

    //     applyButtonStickyDesktop.style.visibility = 'visible';
    //     applyButtonStickyDesktop.removeAttribute('disabled');

    //     // Clear cookies
    //     deleteCookieStickyDesktop('discount_code');
    //     deleteCookieStickyDesktop('discount_amount');
    //     deleteCookieStickyDesktop('discount_type');

    //     // --- New --- Remove from cart attributes ---
    //     fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({
    //             attributes: {
    //                 discount_code: '',
    //                 discount_amount: '',
    //                 discount_type: ''
    //             }
    //         })
    //     })
    //     .then(() => {
    //         window.location.href = '/checkout?discount=PERCENTREDUC25';
    //     })
    // }

    // function removeDiscountStickyDesktop() {
    //     totalPriceStickyDesktop.textContent = originalTotalStickyDesktop.toFixed(2).replace('.', ',') + ' €';
    //     vatAmountStickyDesktop.textContent = originalVatStickyDesktop.toFixed(2).replace('.', ',') + ' €';
    //     discountMessageStickyDesktop.textContent = '';
    //     discountMessageStickyDesktop.style.display = 'none';
    //     errorMessageStickyDesktop.textContent = '';
    //     errorMessageStickyDesktop.style.display = 'none';
    //     promoInputStickyDesktop.value = '';
    //     promoInputStickyDesktop.disabled = false;
    //     promoInputStickyDesktop.parentNode.classList.remove("applied");
    //     const clearBtn = document.querySelector('.clear-discount-sticky');
    //     if (clearBtn) clearBtn.remove();
    //     applyButtonStickyDesktop.style.visibility = 'visible';
    //     applyButtonStickyDesktop.removeAttribute('disabled');
    //     deleteCookieStickyDesktop('discount_code');
    //     deleteCookieStickyDesktop('discount_amount');
    //     deleteCookieStickyDesktop('discount_type');
    //     fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({
    //             attributes: {
    //                 discount_code: null,  // Use null to properly remove from cart
    //                 discount_amount: null,
    //                 discount_type: null
    //             }
    //         })
    //     })
    //     .then(response => {
    //         if (!response.ok) {
    //             throw new Error('Failed to clear discount from cart.');
    //         }
    //         return response.json();
    //     })
    //     .then(cart => {
    //         console.log('Discount attributes removed:', cart);
    //     })
    //     .catch(error => {
    //         console.error('Error removing discount:', error);
    //     });
    // }

    // Helper functions for cookies
    function setCookieStickyDesktop(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; Secure; SameSite=Lax`;
    }

    function getCookieValueStickyDesktop(name) {
        const cookies = document.cookie.split('; ');
        const cookie = cookies.find(row => row.startsWith(`${name}=`));
        return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
    }

    function deleteCookieStickyDesktop(name) {
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const promoInputStickyMobile = document.getElementById('promo-code-mobile-sticky');
    const discountMessageStickyMobile = document.getElementById('discount-message-mobile-sticky');
    const errorMessageStickyMobile = document.getElementById('error-message-mobile-sticky');
    const totalPriceStickyMobile = document.querySelector('.header-mobile-sticky-cart .total-price-container .price-ttc');
    const vatAmountStickyMobile = document.querySelector('.header-mobile-sticky-cart .total-price-container .tva-total-price'); // New VAT Element
    const applyButtonStickyMobile = promoInputStickyMobile.nextElementSibling;
    const promoCodeLabelStickyMobile = document.querySelector('.promo-label-mobile');
    const promoCodeCoverStickyMobile = document.querySelector('.promo-code-mobile');

    let originalTotalStickyMobile = parseFloat(totalPriceStickyMobile.textContent.replace(window.currencySymbol, '').replace(',', '.'));
    let originalVatStickyMobile = parseFloat(vatAmountStickyMobile.textContent.replace(window.currencySymbol, '').replace(',', '.'));


    // Get discount data from cookies
    const discountCodeStickyMobile = getCookieValueStickyMobile('discount_code');
    const discountAmountStickyMobile = parseFloat(getCookieValueStickyMobile('discount_amount'));
    const discountTypeStickyMobile = getCookieValueStickyMobile('discount_type');

    // If discount exists, restore it
    if (discountCodeStickyMobile && discountAmountStickyMobile && discountTypeStickyMobile) {
        promoInputStickyMobile.value = discountCodeStickyMobile; // Show code in input
        applyDiscountCodeStickyMobile(discountCodeStickyMobile, discountAmountStickyMobile, discountTypeStickyMobile, originalTotalStickyMobile, originalVatStickyMobile, false);
    }

    // Enable/Disable apply button based on input
    promoInputStickyMobile.addEventListener('input', () => {
        applyButtonStickyMobile.disabled = promoInputStickyMobile.value.trim() === '';
    });

    applyButtonStickyMobile.addEventListener('click', () => {
        const code = promoInputStickyMobile.value.trim();
        if (code) {
            applyDiscountCodeStickyMobile(code, null, null, originalTotalStickyMobile, originalVatStickyMobile, true);
        }
    });

   promoInputStickyMobile.oninput = () => {
      if (promoInputStickyMobile.value.trim() === '') {
        errorMessageStickyMobile.style.display = 'none';
        applyButtonStickyMobile.classList.remove("error");
      }
    };


    function applyDiscountCodeStickyMobile(code, savedDiscountAmount, savedDiscountType, originalTotalStickyMobile, saveToCookies = true) {
    const url = `https://app.joraleka.com/discount.php?discount_code=${encodeURIComponent(code)}`;

    fetch(url)
        .then(response => response.json())
        .then(data => {
            errorMessageStickyMobile.textContent = '';
            errorMessageStickyMobile.style.display = 'none';

            if (data.value && data.value_type) {
                let discountAmount = savedDiscountAmount !== null ? savedDiscountAmount : parseFloat(data.value);
                let discountType = savedDiscountType || data.value_type;
                
                let total = originalTotalStickyMobile;
                let vatAmount = originalVatStickyMobile;
                let deduction = 0;
                let vatDeduction = 0;
                let deductionMessage = '';

                // --- FIX: Restoration Detection ---
                // If we are RESTORING (savedDiscountAmount is not null), Shopify already applied the discount.
                // We show the message but do NOT subtract the math again.
                if (discountType === 'fixed_amount') {
                    deduction = Math.abs(discountAmount);
                    vatDeduction = (deduction * originalVatStickyMobile) / originalTotalStickyMobile;
                    
                    if (savedDiscountAmount === null) {
                        total -= deduction;
                        vatAmount -= vatDeduction;
                    }
                    deductionMessage = `${deduction.toFixed(2).replace('.', ',')} ${window.currencySymbol}`;
                } else if (discountType === 'percentage') {
                    // Calculate deduction relative to the true original price
                    let preDiscountTotal = (savedDiscountAmount !== null) ? (total / (1 - (Math.abs(discountAmount) / 100))) : total;
                    deduction = preDiscountTotal * (Math.abs(discountAmount) / 100);
                    vatDeduction = (originalVatStickyMobile * (Math.abs(discountAmount) / 100));

                    if (savedDiscountAmount === null) {
                        total -= deduction;
                        vatAmount -= vatDeduction;
                    }
                    deductionMessage = `${discountAmount.toFixed(0)}% soit ${deduction.toFixed(2).replace('.', ',')} ${window.currencySymbol}`;
                }

                // Update UI
                totalPriceStickyMobile.textContent = Math.max(total, 0).toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;
                vatAmountStickyMobile.textContent = Math.max(vatAmount, 0).toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;
                
                discountMessageStickyMobile.innerHTML = deductionMessage + ` <sup>inc. VAT</sup>`;
                discountMessageStickyMobile.style.display = 'block';
                promoCodeCoverStickyMobile.style.display = 'flex';
                promoCodeLabelStickyMobile.classList.add('active');
                promoInputStickyMobile.disabled = true;
                applyButtonStickyMobile.disabled = true;
                applyButtonStickyMobile.style.visibility = 'hidden';

                addClearButtonStickyMobile();

                if (saveToCookies) {
                    setCookieStickyMobile('discount_code', code, 1);
                    setCookieStickyMobile('discount_amount', discountAmount, 1);
                    setCookieStickyMobile('discount_type', discountType, 1);
                }

                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        attributes: {
                            discount_code: code,
                            discount_amount: discountAmount,
                            discount_type: discountType
                        }
                    })
                });
            } else {
                handleDiscountErrorStickyMobile(data);
            }
        });
}

    // --- New --- Load discount from Shopify cart attributes if exists ---
// --- Updated Mobile Sync Logic ---
if (document.querySelector('.header-mobile-sticky-cart')) {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        // PRIORITY 1: Check Shopify Server Session
        if (!cart.cart_level_discount_applications || cart.cart_level_discount_applications.length === 0) {
            console.log("Sticky Mobile: No active discount on server. Cleaning local data.");
            removeDiscountStickyMobile(); // Call your reset function
            return;
        }

        // PRIORITY 2: Restore from Attributes
        if (cart.attributes && cart.attributes.discount_code && cart.attributes.discount_amount && cart.attributes.discount_type) {
            const discountCode = cart.attributes.discount_code;
            const discountAmount = parseFloat(cart.attributes.discount_amount);
            const discountType = cart.attributes.discount_type;

            promoInputStickyMobile.value = discountCode; 
            applyDiscountCodeStickyMobile(discountCode, discountAmount, discountType, originalTotalStickyMobile, false);
        
        // PRIORITY 3: Restore from Session
        } else {
            const discountApp = cart.cart_level_discount_applications[0];
            if (discountApp && discountApp.type === 'discount_code') {
                const discountCode = discountApp.title || '';
                const discountAmount = parseFloat(discountApp.value) || 0;
                const discountType = (discountAmount > 0 && discountAmount <= 100) ? 'percentage' : 'fixed_amount';

                promoInputStickyMobile.value = discountCode;
                applyDiscountCodeStickyMobile(discountCode, discountAmount, discountType, originalTotalStickyMobile, false);
            }
        }
    })
    .catch(error => console.error("Sticky Mobile Fetch Error:", error));
}

    function handleDiscountErrorStickyMobile(data) {
        const errorMessages = {
            error: errorMessageStickyMobile.dataset.textError,
            limit_reach: errorMessageStickyMobile.dataset.textLimitreach,
            expire: errorMessageStickyMobile.dataset.textExpire,
            customer_error: errorMessageStickyMobile.dataset.textCustomererror,
            product_error: errorMessageStickyMobile.dataset.textProducterror,
            mini_order: errorMessageStickyMobile.dataset.textMiniorder,
        };

        const errorMessage = errorMessages[data.error] || errorMessages.error || 'Invalid Discount Code';
        errorMessageStickyMobile.textContent = errorMessage;
        applyButtonStickyMobile.classList.add("error");
        errorMessageStickyMobile.style.display = 'block';
        discountMessageStickyMobile.style.display = 'none';
    }

    function addClearButtonStickyMobile() {
        // Check if button already exists to avoid duplicates
        if (!document.querySelector('.clear-discount-sticky-mobile')) {
            const clearBtn = document.createElement('button');
            clearBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0602/6376/0064/files/cross-ic.svg?v=1741066569" alt="cross icon" width="15" height="15" style="cursor: pointer;">';
            clearBtn.className = 'clear-discount-sticky-mobile';
            clearBtn.style.marginLeft = '10px';
            clearBtn.addEventListener('click', removeDiscountStickyMobile);
            promoInputStickyMobile.parentNode.appendChild(clearBtn);
            promoInputStickyMobile.parentNode.classList.add("applied");
        }
    }
    function removeDiscountStickyMobile() {
    // 1. Find the true original subtotal source
    const subtotalEl = document.querySelector('.header-mobile-sticky-cart .top-subtotal .price-ttc') || document.querySelector('.top-subtotal .price-ttc');
    const vatSubtotalEl = document.querySelector('.header-mobile-sticky-cart .subtotal-tva-total-price') || document.querySelector('.subtotal-tva-total-price');

    const trueOriginalTotal = parseFloat(subtotalEl.textContent.replace(window.currencySymbol, '').replace(',', '.'));
    const trueOriginalVAT = parseFloat(vatSubtotalEl.textContent.replace(window.currencySymbol, '').replace(',', '.'));

    // 2. Force UI back to 1000
    totalPriceStickyMobile.textContent = trueOriginalTotal.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;
    vatAmountStickyMobile.textContent = trueOriginalVAT.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;

    // 3. UI Reset
    discountMessageStickyMobile.textContent = '';
    discountMessageStickyMobile.style.display = 'none';
    errorMessageStickyMobile.textContent = '';
    errorMessageStickyMobile.style.display = 'none';
    promoInputStickyMobile.value = '';
    promoInputStickyMobile.disabled = false;
    promoInputStickyMobile.parentNode.classList.remove("applied");

    const clearBtn = document.querySelector('.clear-discount-sticky-mobile');
    if (clearBtn) clearBtn.remove();

    applyButtonStickyMobile.style.visibility = 'visible';
    applyButtonStickyMobile.removeAttribute('disabled');

    // 4. Cleanup
    deleteCookieStickyMobile('discount_code');
    deleteCookieStickyMobile('discount_amount');
    deleteCookieStickyMobile('discount_type');

    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            discount: "", // Clears Shopify Session
            attributes: {
                discount_code: '',
                discount_amount: '',
                discount_type: ''
            }
        })
    }).then(() => {
        if (typeof syncCartDataDiscount === 'function') syncCartDataDiscount();
    });
}
    // function removeDiscountStickyMobile() {
    //     totalPriceStickyMobile.textContent = originalTotalStickyMobile.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;
    //     vatAmountStickyMobile.textContent = originalVatStickyMobile.toFixed(2).replace('.', ',') + ' ' + window.currencySymbol;

    //     discountMessageStickyMobile.textContent = '';
    //     discountMessageStickyMobile.style.display = 'none';
    //     errorMessageStickyMobile.textContent = '';
    //     errorMessageStickyMobile.style.display = 'none';
    //     promoInputStickyMobile.value = '';
    //     promoInputStickyMobile.disabled = false;
    //     promoInputStickyMobile.parentNode.classList.remove("applied");

    //     const clearBtn = document.querySelector('.clear-discount-sticky-mobile');
    //     if (clearBtn) clearBtn.remove();

    //     applyButtonStickyMobile.style.visibility = 'visible';
    //     applyButtonStickyMobile.removeAttribute('disabled');

    //     // Clear cookies
    //     deleteCookieStickyMobile('discount_code');
    //     deleteCookieStickyMobile('discount_amount');
    //     deleteCookieStickyMobile('discount_type');

    //     // --- New --- Remove from cart attributes ---
    //     fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({
    //             attributes: {
    //                 discount_code: '',
    //                 discount_amount: '',
    //                 discount_type: ''
    //             }
    //         })
    //     })
    //     .then(() => {
    //         window.location.href = '/checkout?discount=PERCENTREDUC25';
    //     })
    // }

    // function removeDiscountStickyMobile() {
    //     // Restore original totals
    //     totalPriceStickyMobile.textContent = originalTotalStickyMobile.toFixed(2).replace('.', ',') + ' €';
    //     vatAmountStickyMobile.textContent = originalVatStickyMobile.toFixed(2).replace('.', ',') + ' €';
    
    //     // Clear discount messages
    //     discountMessageStickyMobile.textContent = '';
    //     discountMessageStickyMobile.style.display = 'none';
    //     errorMessageStickyMobile.textContent = '';
    //     errorMessageStickyMobile.style.display = 'none';
    
    //     // Reset promo input
    //     promoInputStickyMobile.value = '';
    //     promoInputStickyMobile.disabled = false;
    //     promoInputStickyMobile.parentNode.classList.remove("applied");
    
    //     // Remove clear button if exists
    //     const clearBtn = document.querySelector('.clear-discount-sticky-mobile');
    //     if (clearBtn) clearBtn.remove();
    
    //     // Enable apply button
    //     applyButtonStickyMobile.style.visibility = 'visible';
    //     applyButtonStickyMobile.removeAttribute('disabled');
    
    //     // Delete discount cookies
    //     deleteCookieStickyMobile('discount_code');
    //     deleteCookieStickyMobile('discount_amount');
    //     deleteCookieStickyMobile('discount_type');
    
    //     // Safely remove discount-related cart attributes without affecting line items
    //     fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({
    //             attributes: {
    //                 discount_code: null,   // Use null instead of '' for better clarity
    //                 discount_amount: null,
    //                 discount_type: null
    //             }
    //         })
    //     })
    //     .then(response => {
    //         if (!response.ok) {
    //             throw new Error('Failed to clear discount from cart.');
    //         }
    //         return response.json();
    //     })
    //     .then(cart => {
    //         console.log('Discount attributes removed:', cart);
    //         // Optional: Update UI or trigger cart refresh
    //     })
    //     .catch(error => {
    //         console.error('Error removing discount:', error);
    //     });
    // }

    // Helper functions for cookies
    function setCookieStickyMobile(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; Secure; SameSite=Lax`;
    }

    function getCookieValueStickyMobile(name) {
        const cookies = document.cookie.split('; ');
        const cookie = cookies.find(row => row.startsWith(`${name}=`));
        return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
    }

    function deleteCookieStickyMobile(name) {
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
    }

});




const afterDiv = document.querySelector(".promo-code");
const promoLabel = document.querySelector(".promo-label");
const errorMessageCart = document.getElementById('error-message');
const errorMessageCartSticky = document.getElementById('error-message-desktop-sticky');
const ApplyButton = document.querySelector(".apply-button");

promoLabel.addEventListener("click", function () {
    if (afterDiv.style.display === "flex") {
        afterDiv.style.display = "none"; // Hide the div
        promoLabel.classList.remove("active"); // Remove active class
        
    } else {
        afterDiv.style.display = "flex"; // Show the div
        promoLabel.classList.add("active"); // Add active class
    }
});



const afterDivMobile = document.querySelector(".promo-code-mobile");
const promoLabelMobile = document.querySelector(".promo-label-mobile");
const errorMessageMobile = document.getElementById('error-message-mobile-sticky');
const promoInputStickyMobile = document.getElementById('promo-code-mobile-sticky');

if (afterDivMobile && promoLabelMobile) { // Ensure elements exist
    promoLabelMobile.addEventListener("click", function () {
        if (afterDivMobile.style.display === "none" || afterDivMobile.style.display === "") {
            afterDivMobile.style.display = "flex"; // Show the div
            promoLabelMobile.classList.add("active"); // Add active class
            
        } else {
            afterDivMobile.style.display = "none"; // Hide the div
            promoLabelMobile.classList.remove("active"); // Remove active class
        }
    });
}




const updateStickySyncCart = async () => {
    try {
        if (!window.customerId) {
            console.log("❌ Customer not logged in");
            return;
        }

        // Fetch cart data from the API
        const response = await fetch(`https://app.joraleka.com/cart-sync.php?customer_id=${window.customerId}`);
        const data = await response.json();

        if (!data.cartData) {
            console.log("🔥 No cart data found from API");
            return;
        }

        console.log("🔍 Private API Cart Data:", data.cartData);

        // Convert API response to cart array
        const apiCartItems = data.cartData.split(",").map(item => {
            const [id, qty] = item.split(":");
            return { id: parseInt(id), quantity: parseInt(qty) };
        });

        if (!Array.isArray(apiCartItems) || apiCartItems.length === 0) {
            console.log("❌ Invalid cart data from API");
            return;
        }

        // Fetch current Shopify cart
        const shopifyCartResponse = await fetch('/cart.js');
        const shopifyCart = await shopifyCartResponse.json();
        console.log('🛒 Current Shopify Cart:', shopifyCart);

        const currentCartItems = shopifyCart.items || [];

        // Prepare cart updates
        const updates = {};
        apiCartItems.forEach(item => {
            updates[item.id] = item.quantity;
        });

        // Send update request to Shopify cart
        const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates })
        });

        const updatedCart = await updateResponse.json();
        console.log("✅ Shopify Cart Updated:", updatedCart);

        // **Fix: Add a slight delay before refreshing UI**
        // setTimeout(async () => {
        //     await refreshStickyCartUI();
        // }, 300); // Wait 300ms to allow Shopify to update

    } catch (error) {
        console.error("❌ Error updating sticky cart:", error);
    }
};




document.addEventListener("DOMContentLoaded", async () => {
 
  
  console.log("Page Loaded ✅");

  let lastCartData = "";

   const saveCartData = async () => {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      if (cart.items.length === 0) {
        console.log("Cart Empty - Clearing Metafield 🔥");

        if (window.CF?.customer?.isLoggedIn && lastCartData) {
          await CF.customer.set("cart_data", "");
          await CF.customer.save();
          console.log("Metafield Cleared ✅");
        }

        lastCartData = "";
        return;
      }
      const currency = cart.currency || "USD";
      let cartMap = new Map();

      cart.items.forEach((item) => {
        cartMap.set(item.id.toString(), {
          id: item.id.toString(),
          quantity: item.quantity,
          price: (item.price / 100).toFixed(2),
          currency: currency,
        });
      });

      const finalCart = Array.from(cartMap.values())
         .map((item) => `${item.id}:${item.quantity}:${item.price}:${item.currency}`)
        .join(",");

      if (finalCart === lastCartData) {
        console.log("No Changes 🔥 Skipping Save");
        return;
      }

      lastCartData = finalCart;

      if (window.CF?.customer?.isLoggedIn) {
        await CF.customer.set("cart_data", finalCart);
        await CF.customer.save();
        console.log("Metafield Updated ✅");
      }
    } catch (error) {
      console.error("Save Cart Error:", error);
    }
  };

  // const syncCartData = async () => {
  //   if (CF.customer.isLoggedIn) {
  //     const metafield = await CF.customer.get("cart_data");

  //     console.log("Metafield:", metafield);

  //     await fetch("/cart/clear.js", { method: "POST" });
  //     console.log("Cart Cleared ✅");

  //     if (!metafield || metafield === "") {
  //       console.log("Metafield Empty 🔥");
  //       return;
  //     }

  //     const metafieldItems = metafield.split(",").map((item) => {
  //       const [id, qty] = item.split(":");
  //       return { id: parseInt(id), quantity: parseInt(qty) };
  //     });

  //     for (let item of metafieldItems) {
  //       if (item.quantity > 0) {
  //         await fetch("/cart/add.js", {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({ id: item.id, quantity: item.quantity }),
  //         });
  //       }
  //     }
  //     console.log("Cart Synced ✅");
  //     updateStickyCart();
  //   }
  // };

  // const syncCartData = async () => {
  //   if (!window.customerId) {
  //     console.log("❌ Customer not logged in");
  //     return;
  //   }
  
  //   try {
  //     // Fetch cart data from the Private App API
  //     const response = await fetch(`https://app.joraleka.com/cart-sync.php?customer_id=${window.customerId}`);
  //     const data = await response.json();
  
  //     if (!data.cartData) {
  //       console.log("🔥 No cart data found from API");
  //       return;
  //     }
  
  //     console.log("🔍 Private API Cart Data:", data.cartData);
  
  //     // Convert API response into cart array
  //     const metafieldItems = data.cartData.split(",").map(item => {
  //       const [id, qty] = item.split(":");
  //       return { id: parseInt(id), quantity: parseInt(qty) };
  //     });
  
  //     if (!Array.isArray(metafieldItems) || metafieldItems.length === 0) {
  //       console.log("❌ Invalid cart data from API");
  //       return;
  //     }
  
  //     // Clear the current Shopify cart before syncing
  //     await fetch("/cart/clear.js", { method: "POST" });
  //     console.log("🛒 Shopify Cart Cleared ✅");
  
  //     // Add items from metafield data to Shopify cart
  //     for (let item of metafieldItems) {
  //       if (item.quantity > 0) {
  //         await fetch("/cart/add.js", {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({ id: item.id, quantity: item.quantity }),
  //         });
  //       }
  //     }
  
  //     console.log("✅ Cart Synced with Private API!");
  //     updateStickySyncCart();
  
  //   } catch (error) {
  //     console.error("❌ Error syncing cart:", error);
  //   }
  // };

const updateCartCount = (cartItems) => {
    const cartCountElement = document.querySelector(".header-cart-count"); // Desktop
    const cartCountElementMobile = document.querySelector(".header-mobile-container .header-cart-count"); // Mobile

    const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

    // Update desktop count (only the number)
    if (cartCountElement && !cartCountElement.closest(".header-mobile-container")) {
        cartCountElement.textContent = totalItems;
    }

    // Update mobile count (keep "Cart (10)" format)
    if (cartCountElementMobile) {
        const currentText = cartCountElementMobile.textContent;
        const updatedText = totalItems; // Replace only the number inside parentheses
        cartCountElementMobile.textContent = updatedText;
    }

    console.log(`🔄 Cart count updated: ${totalItems}`);
};


  
const updateStickyCartItems = (cartData) => {
  const currencySymbol = window.currencySymbol;

  console.log("currencySymbol",currencySymbol)
 const cartItems = cartData.items;
  let stickyCartContainer = document.querySelector(".sticky-cart .cart-items-wrapper");
  let stickyCartContainerMobile = document.querySelector(".header-mobile-sticky-cart .mobile_cart_cover");

  if (!stickyCartContainer) {
    setTimeout(() => updateStickyCartItems(cart), 1000);
    return;
  }

  const cartItemIds = new Set(cartItems.map(item => item.id.toString()));

  // Remove outdated items - Desktop
  stickyCartContainer.querySelectorAll(".cart-item-container").forEach(stickyItem => {
    const itemKey = stickyItem.getAttribute("data-key")?.split(":")[0];
    if (!cartItemIds.has(itemKey)) stickyItem.remove();
  });

  // Remove outdated items - Mobile
  if (stickyCartContainerMobile) {
    stickyCartContainerMobile.querySelectorAll(".cart-item-container").forEach(stickyItem => {
      const itemKey = stickyItem.getAttribute("data-key")?.split(":")[0];
      if (!cartItemIds.has(itemKey)) stickyItem.remove();
    });
  }

  // Totals
  const hasDiscount = cartData.total_discount > 0;
  let totalTTC = 0;
  let totalVAT = 0;
  const taxRate = 0.2;
  const taxCoeff = 1 + taxRate;

  cartItems.forEach(item => {
    const itemKey = item.id.toString();
    const image = item.image || 'https://cdn.shopify.com/s/files/1/0602/6376/0064/files/Group48095520_d0bf0cae-5590-43a3-9ccc-831beabcc11f-min.png?v=1703143108';

    const finalLinePrice = item.final_line_price || item.line_price; // cents
    const itemPriceTTC = finalLinePrice / 100;
    const itemUnitPrice = itemPriceTTC / item.quantity;
    const itemTax = (itemPriceTTC / taxCoeff) * taxRate;

    totalTTC += itemPriceTTC;
    totalVAT += itemTax;

    // Desktop cart item
    const existingItemDesktop = stickyCartContainer.querySelector(`.cart-item-container[data-key^="${itemKey}:"]`);
    if (!existingItemDesktop) {
      let newItem = document.createElement("div");
      newItem.classList.add("cart-item-container");
      newItem.setAttribute("data-key", item.key);
      newItem.innerHTML = `
        <div class="delete-column">
            <button class="open-delete" aria-label="Supprimer le produit du panier et de la commande" data-key="${item.key}">
                <svg class="svg-open-delete" xmlns="http://www.w3.org/2000/svg" width="25.761" height="32.201" viewBox="0 0 25.761 32.201">
                    <path class="path-open-delete" id="icons8-trash-can" d="M13.66,2,12.05,3.61H5.61a1.61,1.61,0,0,0,0,3.22H28.151a1.61,1.61,0,0,0,0-3.22h-6.44L20.1,2ZM5.61,10.05V30.981A3.219,3.219,0,0,0,8.83,34.2h16.1a3.219,3.219,0,0,0,3.22-3.22V10.05Z" transform="translate(-4 -2)"></path>
                </svg>
            </button>
            <div class="cart-popin-delete dv">
                <button class="button-popin-delete cancel">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.516" height="15.516" viewBox="0 0 15.516 15.516">
                        <path id="icons8-close-window" d="M11.706,9.875,9.875,11.706l5.911,5.921L9.875,23.539l1.831,1.852,5.921-5.921,5.911,5.921,1.852-1.852-5.921-5.911,5.921-5.921L23.539,9.875l-5.911,5.911Z" transform="translate(-9.875 -9.875)"></path>
                    </svg>
                    <span>Annuler</span>
                </button>

                <div class="content-delete">
                    <span class="content-delete-text">Êtes-vous sûr de vouloir supprimer cette tâche ?</span>
                </div>

                <button class="button-popin-delete confirm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.743" height="22.178" viewBox="0 0 17.743 22.178">
                        <path id="icons8-trash-can" d="M10.654,2,9.545,3.109H5.109a1.109,1.109,0,0,0,0,2.218H20.634a1.109,1.109,0,0,0,0-2.218H16.2L15.089,2ZM5.109,7.545V21.961a2.217,2.217,0,0,0,2.218,2.218H18.416a2.217,2.217,0,0,0,2.218-2.218V7.545Z" transform="translate(-4 -2)"></path>
                    </svg>  
                    <span>Confirmer</span>
                </button>
            </div>
        </div>

        <div class="image-column">
            <img width="60" height="68" class="line-item-img" src="${image}" loading="lazy" alt="${item.title}">
        </div>

        <div class="content-column">
            <span class="sku">${item.sku}</span>
            <h4>${item.title}</h4>
            <div class="url-shopify">
                <svg xmlns="http://www.w3.org/2000/svg" width="15.809" height="15.912" viewBox="0 0 15.809 15.912">
                  <path id="icons8-internet" d="M9.906,2A7.89,7.89,0,0,0,3.6,5.162H3.582v.02a7.879,7.879,0,0,0-1.5,3.625A8.04,8.04,0,0,0,7,17.2a7.059,7.059,0,0,0,2.907.615.791.791,0,0,0,.787-.794V10.7a.791.791,0,0,0-.791-.791H8.325a.791.791,0,1,1,.009-1.581.784.784,0,0,0,.781-.791V6.743a.791.791,0,0,1,.791-.791H10.7a1.581,1.581,0,0,0,1.581-1.581V4.047a6.331,6.331,0,0,1,3.953,5.858c0,.009,0,.018,0,.028h0a.79.79,0,0,0,1.58-.028q0-.037,0-.074A7.913,7.913,0,0,0,9.906,2ZM3.747,8.49l3.788,3.788v.791a1.581,1.581,0,0,0,1.581,1.581v1.527A6.3,6.3,0,0,1,3.747,8.49Zm9.031.607a.567.567,0,0,0-.5.565v5.647a.4.4,0,0,0,.669.286l1.129-1.073L15.3,17.34a.947.947,0,1,0,1.732-.767L15.8,13.858h1.246a.4.4,0,0,0,.275-.679L13.243,9.252A.56.56,0,0,0,12.778,9.1Z" transform="translate(-2.003 -2)"></path>
                </svg>
                <span>Undefined Website</span>
            </div>                        
        </div>

        <div class="price-column">
            <div class="item-price-container">
                <span class="price-ttc">${(item.price / 100).toFixed(2)} ${currencySymbol}</span>
                <span class="cart-ttc">inc. VAT</span>
                <span class="item-tva">Inc. VAT: ${itemTax.toFixed(2)} ${currencySymbol}</span>
            </div>
        </div>
    `;
      stickyCartContainer.appendChild(newItem);
    }

    // Mobile cart item
    const existingItemMobile = stickyCartContainerMobile?.querySelector(`.cart-item-container[data-key^="${itemKey}:"]`);
    if (stickyCartContainerMobile && !existingItemMobile) {
      let newItemMobile = document.createElement("div");
      newItemMobile.classList.add("cart-item-container");
      newItemMobile.setAttribute("data-key", item.key);
      newItemMobile.innerHTML = `
        <div class="delete-column">
            <button class="open-delete" aria-label="Supprimer le produit du panier et de la commande" data-key="${item.key}">
                <svg class="svg-open-delete" xmlns="http://www.w3.org/2000/svg" width="25.761" height="32.201" viewBox="0 0 25.761 32.201">
                    <path class="path-open-delete" id="icons8-trash-can" d="M13.66,2,12.05,3.61H5.61a1.61,1.61,0,0,0,0,3.22H28.151a1.61,1.61,0,0,0,0-3.22h-6.44L20.1,2ZM5.61,10.05V30.981A3.219,3.219,0,0,0,8.83,34.2h16.1a3.219,3.219,0,0,0,3.22-3.22V10.05Z" transform="translate(-4 -2)"></path>
                </svg>
            </button>
            <div class="cart-popin-delete dv">
                <button class="button-popin-delete cancel">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.516" height="15.516" viewBox="0 0 15.516 15.516">
                        <path id="icons8-close-window" d="M11.706,9.875,9.875,11.706l5.911,5.921L9.875,23.539l1.831,1.852,5.921-5.921,5.911,5.921,1.852-1.852-5.921-5.911,5.921-5.921L23.539,9.875l-5.911,5.911Z" transform="translate(-9.875 -9.875)"></path>
                    </svg>
                    <span>Annuler</span>
                </button>

                <div class="content-delete">
                    <span class="content-delete-text">Êtes-vous sûr de vouloir supprimer cette tâche ?</span>
                </div>

                <button class="button-popin-delete confirm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.743" height="22.178" viewBox="0 0 17.743 22.178">
                        <path id="icons8-trash-can" d="M10.654,2,9.545,3.109H5.109a1.109,1.109,0,0,0,0,2.218H20.634a1.109,1.109,0,0,0,0-2.218H16.2L15.089,2ZM5.109,7.545V21.961a2.217,2.217,0,0,0,2.218,2.218H18.416a2.217,2.217,0,0,0,2.218-2.218V7.545Z" transform="translate(-4 -2)"></path>
                    </svg>  
                    <span>Confirmer</span>
                </button>
            </div>
        </div>

        <div class="image-column">
            <img width="60" height="68" class="line-item-img" src="${image}" loading="lazy" alt="${item.title}">
        </div>

        <div class="content-column">
            <span class="sku">${item.sku}</span>
            <h4>${item.title}</h4>
            <div class="url-shopify">
                <svg xmlns="http://www.w3.org/2000/svg" width="15.809" height="15.912" viewBox="0 0 15.809 15.912">
                  <path id="icons8-internet" d="M9.906,2A7.89,7.89,0,0,0,3.6,5.162H3.582v.02a7.879,7.879,0,0,0-1.5,3.625A8.04,8.04,0,0,0,7,17.2a7.059,7.059,0,0,0,2.907.615.791.791,0,0,0,.787-.794V10.7a.791.791,0,0,0-.791-.791H8.325a.791.791,0,1,1,.009-1.581.784.784,0,0,0,.781-.791V6.743a.791.791,0,0,1,.791-.791H10.7a1.581,1.581,0,0,0,1.581-1.581V4.047a6.331,6.331,0,0,1,3.953,5.858c0,.009,0,.018,0,.028h0a.79.79,0,0,0,1.58-.028q0-.037,0-.074A7.913,7.913,0,0,0,9.906,2ZM3.747,8.49l3.788,3.788v.791a1.581,1.581,0,0,0,1.581,1.581v1.527A6.3,6.3,0,0,1,3.747,8.49Zm9.031.607a.567.567,0,0,0-.5.565v5.647a.4.4,0,0,0,.669.286l1.129-1.073L15.3,17.34a.947.947,0,1,0,1.732-.767L15.8,13.858h1.246a.4.4,0,0,0,.275-.679L13.243,9.252A.56.56,0,0,0,12.778,9.1Z" transform="translate(-2.003 -2)"></path>
                </svg>
                <span>Undefined Website</span>
            </div>                        
        </div>

        <div class="price-column">
            <div class="item-price-container">
                <span class="price-ttc">${(item.price / 100).toFixed(2)} ${currencySymbol}</span>
                <span class="cart-ttc">inc. VAT</span>
                <span class="item-tva">Inc. VAT: ${itemTax.toFixed(2)} ${currencySymbol}</span>
            </div>
        </div>
        `;
      stickyCartContainerMobile.appendChild(newItemMobile);
    }
  });

  // Update totals
  // const subtotalContainer = document.querySelector('.top-subtotal');
  // if (subtotalContainer) {
  //   subtotalContainer.querySelector('.price-ttc').textContent = `${totalTTC.toFixed(2).replace('.', ',')} ${currencySymbol}`;
  //   subtotalContainer.querySelector('.subtotal-tva-total-price').textContent = `${totalVAT.toFixed(2).replace('.', ',')} ${currencySymbol}`;
  // }

  // const totalContainer = document.querySelector('.cart-total-container');
  // if (totalContainer) {
  //   totalContainer.querySelector('.price-ttc').textContent = `${totalTTC.toFixed(2).replace('.', ',')} €`;
  //   totalContainer.querySelector('.tva-total-price').textContent = `${totalVAT.toFixed(2).replace('.', ',')} €`;
  // }

  // Cart item count
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  var stickyCartCount = document.querySelector(".sticky-cart-count");
if (stickyCartCount) stickyCartCount.textContent = totalItems;

 var mobileCartCount = document.querySelector(".header-mobile-sticky-cart .cart-count");
if (mobileCartCount) {
  mobileCartCount.textContent = totalItems;
}


  const emptyCartContainer = document.querySelector(".empty-cart-container");
  const filledCartContainer = document.querySelector(".filled-cart-container");
  const filledCartIcon = document.querySelector(".header-link-cart");

  if (totalItems > 0) {
    emptyCartContainer?.classList.add("hidden");
    filledCartContainer?.classList.remove("hidden");
    filledCartIcon?.classList.remove("cart-is-empty");
  } else {
    emptyCartContainer?.classList.remove("hidden");
    filledCartContainer?.classList.add("hidden");
    filledCartIcon?.classList.add("cart-is-empty");
  }
};












 let isSyncing = false; // Prevent multiple syncs at the same time

const syncCartData = async () => {
    if (!window.customerId) {
        console.log("❌ Customer not logged in - skipping cart-sync");
        return;
    }
    if (isSyncing) {
        console.log("⏳ Sync already in progress... Skipping.");
        return; // Prevent multiple updates at once
    }
    isSyncing = true;

    try {
        console.log("🔄 Fetching latest metafield and cart data...");

        // Fetch metafield once (no second fetch)
        let metafieldResponse = await fetch("https://app.joraleka.com/cart-sync.php?customer_id=" + window.customerId);
        let metafieldData = await metafieldResponse.json();

        if (!metafieldData || !metafieldData.cartData) {
            console.warn("⚠️ No metafield data found, skipping sync.");

            // Clear the Shopify cart if customer has no metafield data
            await fetch("/cart/clear.js", { method: "POST" });
          
            isSyncing = false;
            return;
        }

        console.log("📦 Metafield Data:", metafieldData.cartData);

        // Fetch Shopify cart once
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        console.log("🛒 Current Shopify Cart here:", cartData.items);

        // Update the cart count dynamically
        updateCartCount(cartData.items);
        var count_cart_here = cartData.items.reduce((sum, item) => sum + item.quantity, 0) 
        if(count_cart_here >= 1 ){
          document.querySelectorAll('.header-wrapper .header-mobile-container .header-link-cart-cover .header-link-cart.cart-is-empty').forEach(el => el.classList.remove('cart-is-empty'));
        }else{
          console.log('not empty')
        }
        updateStickyCartItems(cartData);

        // Convert metafield string to array of objects
        const metafieldCartArray = metafieldData.cartData.split(",");
        const cartItemsFromMetafield = metafieldCartArray.map(item => {
            const [id, quantity] = item.split(":");
            return { id, quantity: parseInt(quantity) };
        });

        // Create maps for quick lookup
        let metafieldMap = new Map(cartItemsFromMetafield.map(item => [item.id, item.quantity]));
        let cartMap = new Map(cartData.items.map(item => [item.id.toString(), item.quantity]));

        // Check if cart and metafield are different
        let cartNeedsUpdate = false;
        if (cartMap.size !== metafieldMap.size) {
            cartNeedsUpdate = true;
        } else {
            for (let [id, quantity] of metafieldMap.entries()) {
                if (!cartMap.has(id) || cartMap.get(id) !== quantity) {
                    cartNeedsUpdate = true;
                    break;
                }
            }
        }

        if (cartNeedsUpdate) {
            console.log("🔄 Shopify cart is outdated, updating in bulk...");

            // Prepare the bulk update in one request
            let bulkCartItems = cartItemsFromMetafield.map(item => ({
                id: item.id,
                quantity: item.quantity
            }));

            if (bulkCartItems.length > 0) {
                console.log("🗑 Clearing Shopify cart...");
                await fetch("/cart/clear.js", { method: "POST" });

                console.log("🛍 Adding all items in bulk...");
                await fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ updates: Object.fromEntries(bulkCartItems.map(i => [i.id, i.quantity])) }),
                });

                console.log("✅ Shopify cart successfully updated.");
            }
        } else {
            console.log("✅ Shopify cart is already up-to-date.");
        }

    } catch (error) {
        console.error("❌ Error syncing cart:", error);
    } finally {
        isSyncing = false; // Allow next sync
    }
};











//   document.addEventListener("click", async (e) => {
//     if (e.target.closest(".btn-pay")) {
//         const btn = e.target.closest(".btn-pay");
//         const paymentKey = btn.dataset.paymentKey;
//         const paymentKeys = paymentKey.split("-");
//         let cartMap = new Map();

//         // ✅ Fetch existing metafield data **before updating**
//         let existingCartData = "";
//         if (CF.customer.isLoggedIn) {
//             existingCartData = await CF.customer.get("cart_data") || "";
//             console.log("🔍 Existing Metafield Data Before Update:", existingCartData);
//         }

//         // ✅ Convert existing metafield data to Map
//         if (existingCartData) {
//             existingCartData.split(",").forEach((item) => {
//                 const [itemId, itemQty, itemPrice] = item.split(":");
//                 cartMap.set(itemId, {
//                     id: itemId,
//                     quantity: parseInt(itemQty),
//                     price: itemPrice,
//                 });
//             });
//         }

//         // ✅ Merge new cart items
//         paymentKeys.forEach((key) => {
//             const [id, qty, price] = key.split(":");
//             const quantity = parseInt(qty);
//             const finalPrice = parseFloat(price).toFixed(2);

//             if (cartMap.has(id)) {
//                 let oldItem = cartMap.get(id);
//                 oldItem.quantity += quantity; // ✅ Merge existing & new quantity
//             } else {
//                 cartMap.set(id, {
//                     id: id,
//                     quantity: quantity,
//                     price: finalPrice,
//                 });
//             }
//         });

//         // ✅ Convert back to metafield format
//         const finalCartData = Array.from(cartMap.values())
//             .map((item) => `${item.id}:${item.quantity}:${item.price}`)
//             .join(",");

//         // ✅ Only update metafield if data has changed
//         if (finalCartData !== lastCartData) {
//             lastCartData = finalCartData;
//             localStorage.setItem("lastCartData", finalCartData);

//             if (CF.customer.isLoggedIn) {
//                 await CF.customer.set("cart_data", finalCartData);
//                 await CF.customer.save();
//                 console.log("✅ Metafield Updated with Merged Data:", finalCartData);
//             }

//             await saveCartData();
//             await syncCartData();
//             window.location.href = "/checkout"; // 🔥 Redirect without Reload
//         }
//     }
// });

 document.addEventListener("click", async (e) => {
  if (e.target.closest(".btn-pay")) {
    e.preventDefault(); // always prevent default button behavior
    const btn = e.target.closest(".btn-pay");

    const paymentKey = btn.dataset.paymentKey;
    const symbol = btn.dataset.currencySymbol || "";
    const currency = btn.dataset.currency || "";

    const paymentKeys = paymentKey.split("-");
    let cartMap = new Map();

    paymentKeys.forEach((key) => {
      const [id, qty, price, curr] = key.split(":");
      cartMap.set(id, {
        id,
        quantity: parseInt(qty),
        price: (parseFloat(price) / 100).toFixed(2),
        currency: curr,
        symbol,
      });
    });

    const finalCartData = Array.from(cartMap.values())
      .map((item) => `${item.id}:${item.quantity}:${item.price}:${item.currency}`)
      .join(",");

    console.log("🧾 Final cart data:", finalCartData);

    if (finalCartData !== lastCartData) {
      lastCartData = finalCartData;
      localStorage.setItem("lastCartData", finalCartData);

      if (CF.customer.isLoggedIn) {
        await CF.customer.set("cart_data", finalCartData);
        await CF.customer.save();
      }

      await saveCartData();
      await syncCartData();

      // Always include currency param in redirect
      let checkoutUrl = "/checkout";
      if (currency) {
        checkoutUrl += `?currency=${currency}`;
        console.log("checkoutUrl",checkoutUrl)
      }
      // window.location.href = checkoutUrl;
    }
  }
});


  



  document.addEventListener("click", async (e) => {
    if (e.target.closest(".button-popin-delete.confirm")) {
      const cartItem = e.target.closest(".cart-item-container");
      const key = cartItem.dataset.key;

      if (!key) return;

      const productId = key.split(":")[0];
      console.log(`Deleting Product ID: ${productId} 🔥`);

      let cartMap = new Map();

      if (lastCartData) {
        lastCartData.split(",").forEach((item) => {
          const [itemId, itemQty, itemPrice] = item.split(":");
          cartMap.set(itemId, {
            id: itemId,
            quantity: parseInt(itemQty),
            price: itemPrice,
          });
        });
      }

      if (cartMap.has(productId)) {
        cartMap.delete(productId);
        console.log("Product Removed ✅");

        cartItem.remove();

        const finalCartData = Array.from(cartMap.values())
          .map((item) => `${item.id}:${item.quantity}:${item.price}`)
          .join(",");

        lastCartData = finalCartData;

        if (CF.customer.isLoggedIn) {
          await CF.customer.set("cart_data", finalCartData);
          await CF.customer.save();
          console.log("Metafield Updated After Delete ✅");
        }

        await syncCartData();
        await saveCartData();
      }
    }
  });

  document.addEventListener("cart:updated", async () => {
    await saveCartData();
  });

  await syncCartData();
  await saveCartData();

});



document.addEventListener('DOMContentLoaded', () => {
  console.log("DOMContentLoaded triggered");
  console.log("Fetching cart data...");
  const element = document.querySelector('.alert_message_box');
  const elementMobile = document.querySelector('.alert_message_box.mobile_alert');
  // JORS-3736: cf-api.js (Customer Fields) sets CF.customer asynchronously; when it is not set yet the handler is skipped, as it was before, without the TypeError.
  if (!window.CF || !CF.customer) return;
  const cartData = CF.customer.get("cart_data");
  var cart_meta_data = cartData;
  console.log('cart_meta_data', cart_meta_data);

  if (cart_meta_data) {
    const cartArray = cart_meta_data.split(',').map(item => {
      const [id, quantity, price] = item.split(':'); // Assuming price is also stored
      return { id, quantity: parseInt(quantity, 10), price: parseFloat(price) };
    });
    console.log("Cart data:", cartArray);
    
    if (Array.isArray(cartArray) && cartArray.length > 0) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Current cart:', cart);
          const itemsInCart = cart.items;

          const itemsToUpdate = [];
          let itemPriceChanged = false;
          let itemDeleted = false;

          cartArray.forEach(itemToAdd => {
            const existingItem = itemsInCart.find(itemInCart => itemInCart.id == itemToAdd.id);
            
            if (existingItem) {
              if (existingItem.quantity !== itemToAdd.quantity) {
                itemsToUpdate.push(itemToAdd);
              }
              if (existingItem.final_price / 100 !== itemToAdd.price) { // Convert cents to dollars
                console.log(`Price mismatch for item ${itemToAdd.id}. Expected: ${itemToAdd.price}, Found: ${existingItem.final_price / 100}`);
                itemPriceChanged = true;
              }
            } else {
              console.log(`Item ${itemToAdd.id} not found in the cart.`);
              itemDeleted = true;
            }
          });

          if (itemPriceChanged) {
            element.classList.toggle('active');
            elementMobile.classList.toggle('active');
          }
          if (itemDeleted) {
            element.classList.toggle('active');
            elementMobile.toggle('active');
          }

          if (itemsToUpdate.length > 0) {
            console.log('Items to update:', itemsToUpdate);
            const updates = {};
            itemsToUpdate.forEach(item => {
              updates[item.id] = item.quantity;
            });

            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ updates }),
            });
          } else {
            console.log('Cart quantities already match. No update needed.');
            return Promise.resolve();
          }
        })
        .then(response => response ? response.json() : null)
        .then(data => {
          if (data) {
            console.log('Cart updated successfully!', data);
          }
        })
        .catch(error => {
          console.log('Error updating the cart:', error);
        });
    } else {
      console.log("No valid cart data found.");
    }
  }

  const btnConfirm = document.querySelector('.alert_message_box a');

    if (btnConfirm) btnConfirm.addEventListener('click', (e) => {
       const elements = document.querySelector('.alert_message_box');
        console.log('Button clicked');
      /********************this code is  for cart metafield for customer*************************/
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          // Map the items to extract id and quantity and format them as plain text
          const items = cartData.items
          .map(item => `${item.id}:${item.quantity}:${(item.price / 100).toFixed(2)}`)
          .join(',');

          console.log("cart price",items)
      
          // Set input value with custom formatted cart items
          const cartInput = document.querySelector('.cart-data');
          cartInput.value = items;
      
          console.log('Attempting to save cart data:', items);
      
          // Optionally, ensure CF customer set correctly
          CF.customer.set("cart_data", items);
         elements.classList.remove('active');
          // Save the data
          CF.customer.save().then(() => {
            console.log('Cart data saved successfully.');
           
          }).catch(error => {
            console.error('Error saving cart data:', error);
          });
          
          
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
      /******************** END *************************/
    });

  const btnConfirmMobile = document.querySelector('.alert_message_box .alert_remove');

    if (btnConfirmMobile) btnConfirmMobile.addEventListener('click', (e) => {
       const elementsMobile = document.querySelector('.alert_message_box.mobile_alert');
        console.log('Button clicked');
      /********************this code is  for cart metafield for customer*************************/
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          // Map the items to extract id and quantity and format them as plain text
          const items = cartData.items
          .map(item => `${item.id}:${item.quantity}:${(item.price / 100).toFixed(2)}`)
          .join(',');

          console.log("cart price",items)
      
          // Set input value with custom formatted cart items
          const cartInput = document.querySelector('.cart-data');
          cartInput.value = items;
      
          console.log('Attempting to save cart data:', items);
      
          // Optionally, ensure CF customer set correctly
          CF.customer.set("cart_data", items);
          elementsMobile.classList.remove('active');
          // Save the data
          CF.customer.save().then(() => {
            console.log('Cart data saved successfully.');
           
          }).catch(error => {
            console.error('Error saving cart data:', error);
          });
          
          
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
      /******************** END *************************/
    });
});
